import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useLayoutEffect,
} from "react";
import * as THREE from "three";
import "../App.css";
import imageRotate from "./../images/rotate.png";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import {
  Col,
  Container,
  Row,
  Button,
  Navbar,
  Nav,
  ProgressBar,
  Modal,
} from "react-bootstrap";
// import play from "./play.png";
// import pause from "./pause.png";
// import flecharotate1 from "./flecharotate1.png";
// import flecharotate2 from "./flecharotate2.png";
import * as dat from "lil-gui";
import gsap from "gsap";
// import ScreenQuad from "three-screen-quad";
import { generarScene } from "../funciones/generarScene";

import ModalDestacado from "./ModalDestacadoRendererPrincipal";
import { generarScenePerson } from "../funciones/generarScenePerson";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
import { generarSceneCarousel } from "../funciones/generarSceneCarousel";
import { generarSceneCorgi } from "../funciones/generarSceneCorgi";
import PickHelper2 from "../classes/PickHelper2";
import { Circle } from "rc-progress";
import { MeshStandardMaterial } from "three";
import { generarSmart } from "./../funciones/generarSmart";
import { generarSceneTexto } from "./../funciones/generarSceneTexto";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import Footer from "../layout/Footer";
import { TessellateModifier } from "three/examples/jsm/modifiers/TessellateModifier.js";
import { generarSceneSelect } from "../funciones/generarSceneSelect";
const Canvas = (props) => {
  const [modal, setModal] = useState(false);
  const [tipoLente, setTipoLente] = useState("");
  const [evento, setEvento] = useState(undefined);
  const [activarLenteModal, setActivarLenteModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const handleClose = () => {
    // window.cancelAnimationFrame(refTick2);
    cancelAnimationFrame(refTick2);
    // console.log("se cerro modal");
    // click.estado = false;
    // refObjetoModal.current = null;

    // refScene2.current = null;
    refClick.current = false;
    setModal(false);
  };
  let funcionTick = null;

  let variableCompleto = false;
  const handleShow = () => setModal(true);
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [model, setModel] = useState(undefined);
  const [loading, setLoading] = useState(0);
  const [completo, setCompleto] = useState(false);
  const [estadoResize, setEstadoResize] = useState(false);
  const [mostrarBoton, setMostrarBoton] = useState(false);
  const [error, setError] = useState(false);
  const [primerAnimacion, setPrimerAnimacion] = useState(false);

  const refCanvas = useRef(null);
  const refObjetoModal = useRef(null);
  const refClick = useRef(null);
  // refClick.current = false;
  const refRenderer2 = useRef(null);
  const refTick2 = useRef(null);
  const refRenderer = useRef(null);
  const refElement = useRef(null);
  const refContentModal1 = useRef(null);
  const refSceneModal1 = useRef(null);
  const refModel21 = useRef(null);
  const refModel22 = useRef(null);
  const refModel23 = useRef(null);
  const refCarousel1 = useRef(null);
  const refCarousel2 = useRef(null);
  const refCarousel3 = useRef(null);
  const refModelCarousel1 = useRef(null);
  const refModelCarousel2 = useRef(null);
  const refModelCarousel3 = useRef(null);
  const refPickHelperCarousel1 = useRef(null);
  const refJoe = useRef(null);
  const refMatilda = useRef(null);
  const refJoeClone = useRef(null);
  const refMatildaClone = useRef(null);
  const refCorgi = useRef(null);

  const refPickHelperCarousel2 = useRef(null);
  const refPickHelperCarousel3 = useRef(null);
  const refSceneCarousel1 = useRef(null);
  const refSceneCarousel2 = useRef(null);
  const refSceneCarousel3 = useRef(null);
  const refRendererCorgi = useRef(null);
  const refLenteCarousel1 = useRef(null);
  const refLente1Personaje = useRef(null);
  const refLente2Personaje = useRef(null);
  const refLente3Personaje = useRef(null);
  const refPersonaje = useRef(null);
  const refSmart = useRef(null);
  const refTexto = useRef(null);
  const refPrueba = useRef(null);

  const refMatildaSkin = useRef(null);
  const refMatildaHair = useRef(null);
  const refJoeSkin = useRef(null);
  const refJoeHair = useRef(null);

  const refPickHelperSelectMatilda = useRef(null);
  const refPickHelperSelectJoe = useRef(null);

  const refDivSelect = useRef(null);
  const refDivSelect2 = useRef(null);
  const refDivSelect3 = useRef(null);
  const refDivSelect4 = useRef(null);
  const refDivSelect5 = useRef(null);
  const refDivSelectWidth = useRef(null);

  const refLente1Col = useRef(null);
  const refLente2Col = useRef(null);
  const refLente3Col = useRef(null);

  const textoRotate = useRef(null);
  ///////Textos lentes
  const textoLente1 = useRef(null);
  const textoLente2 = useRef(null);
  const textoLente3 = useRef(null);

  const refFuncionTick = useRef(null);

  const refDivSkin = useRef(null);
  //Ref Tick
  const refTick = useRef(null);
  const refPrimerAnimacion = useRef(null);
  const refBailarMobile = useRef(null);

  const refGsap1 = useRef(null);
  const refGsap2 = useRef(null);
  const refGsap3 = useRef(null);
  const refGsap4 = useRef(null);
  const refGsap5 = useRef(null);
  const refGsap6 = useRef(null);
  const refGsap7 = useRef(null);
  const refGsap8 = useRef(null);
  const refGsap9 = useRef(null);
  const refGsap10 = useRef(null);
  const refGsap11 = useRef(null);
  const refGsap12 = useRef(null);

  // refFuncionModal1.current
  const refFuncionModal1 = useRef(null);
  const refFuncionModal2 = useRef(null);
  const refFuncionModal3 = useRef(null);
  const refModelModal = useRef(null);
  const refTipoModal = useRef(null);

  const refTextoSelect = useRef(null);
  // const refContentModal1 = useRef(null);
  // const refModal = useRef(null);
  /////////////////////////////////////////////////////////////
  const manager = new THREE.LoadingManager();
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath("/draco/"); // use a full url path
  const gltf = new GLTFLoader(manager);
  gltf.setDRACOLoader(dracoLoader);
  const scenes = [];
  const scenes2 = [];
  ////////////////////////////////////////////////////////////////////
  const click = {};
  click.estado = false;
  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);
  //Array Carousel
  const listaCarousel = [
    {
      id: 1,
      ref: "setRef2",
    },
    {
      id: 2,
      ref: "setRef3",
    },
  ];
  // useEffect(() => {
  //   if (!modal) {
  //     if (refRenderer2.current) {
  //       console.log("entra en dispose");
  //       window.cancelAnimationFrame(refTick2.current);
  //       console.log("ref objeto en dispose, ", refObjetoModal.current);
  //       refScene2.current.remove(refObjetoModal.current.name);
  //       refObjetoModal.current = null;
  //       refRenderer2.current.dispose();
  //       refRenderer2.current = null;
  //       refScene2.current = null;
  //     }
  //   }
  // }, [modal]);
  manager.onProgress = function (url, itemsLoaded, itemsTotal) {
    // console.log(
    //   "Loading file: " +
    //     ".\nLoaded " +
    //     itemsLoaded +
    //     " of " +
    //     itemsTotal +
    //     " files."
    // );
    const cantidad = 60;
    let temporal = (itemsLoaded * 100) / cantidad;
    // console.log("temporal es, ", temporal);
    // console.log("items total", itemsTotal);
    setLoading(temporal);
    if (
      parseInt(itemsLoaded) === cantidad &&
      parseInt(itemsTotal) === cantidad
    ) {
      setCompleto(true);
      variableCompleto = true;
      document.body.style.overflow = "auto";
    }
  };

  // useEffect(() => {
  //   if (completo) {
  //     props.completo(true);
  //   }
  // }, [completo]);
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  useEffect(() => {
    // console.log("evento es, ", evento);
  }, [evento]);
  // useEffect(() => {
  //   console.log("refTick2 es, ", refTick2.current);

  class PickHelper {
    constructor() {
      // console.log("props son, ", props);
      // this.props.funcionModal = this.props.funcionModal.bind(this);
      // console.log("props son, ", props);
      this.raycaster = new THREE.Raycaster();
      this.pickedObject = null;
      this.pickedObjectSavedColor = 0;
      this.currentIntersect = null;
      this.scene = undefined;
      this.timer = 0;
      this.activo = false;
      this.estado = 0;
      this.pick = this.pick.bind(this);
      this.activarModal = props;
      // this.handleShow = this.handleShow.bind(this);
      this.stateModal = false;
      if (window.matchMedia("(pointer: coarse)").matches) {
        // touchscreen
        this.isTouch = true;
      } else {
        this.isTouch = false;
      }
    }

    // handleShow = (lente) => {
    //   // this.setState({ modal: true });
    //   this.props.funcionModal("lente21");
    //   console.log("handle class");
    // };
    get getModal() {
      // console.log("entra en getModal");
      // setModalPick(true);
      // this.setState({ modal: true });
      return this.stateModal;
    }
    setModal1(param) {
      // console.log("se ejecuta setmodal1");
      this.stateModal = param;
    }

    // componentWillMount() {
    //   this.pick = this.pick.bind(this);
    // }
    // click() {
    //   console.log("se ejecuta funcion click");
    //   window.addEventListener("click", () => {
    //     console.log("click");
    //     console.log("current2 es, ", this.currentIntersect);

    //     if (this.currentIntersect) {
    //       switch (this.currentIntersect.object.name) {
    //         case "":
    //           alert("click");
    //           console.log("click on object 1");
    //           break;

    //         // case object2:
    //         //   console.log("click on object 2");
    //         //   break;

    //         // case object3:
    //         //   console.log("click on object 3");
    //         //   break;
    //       }
    //     }
    //   });
    // }
    click() {
      // console.log("se ejecuta funcion click");
      window.addEventListener("click", () => {
        // console.log("click");
        // console.log("current2 es, ", this.currentIntersect);

        if (this.currentIntersect) {
          // alert("click11");
          // console.log("this.currentIntersect", this.currentIntersect);
          switch (true) {
            case this.currentIntersect.object.name.includes("lente21"):
              // document.getElementById("canvas-modal").style.zIndex = "99993";
              // this.stateModal = true;
              refFuncionModal1.current();
              // console.log("click on object 21");
              break;
            case this.currentIntersect.object.name.includes("lente22"):
              // this.stateModal = true;
              refFuncionModal2.current();

              // console.log("click on object 22");
              break;
            case this.currentIntersect.object.name.includes("lente23"):
              // this.stateModal = true;
              refFuncionModal3.current();

              // console.log("click on object 23");
              break;
          }
        }
      });
      // window.addEventListener("resize", () => {
      //   // console.log("click");
      //   // console.log("current2 es, ", this.currentIntersect);

      //   this.isTouch =
      //     "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
      //   // console.log("resize es, ", this.isTouch);
      // });
      // window.addEventListener("touchstart", () => {
      //   // console.log("touch1");
      //   // console.log("current3 es, ", this.currentIntersect);

      //   if (this.currentIntersect) {
      //     // this.activo = true;
      //     // alert("click12");
      //     switch (this.currentIntersect.object.name) {
      //       case "":
      //         // console.log("click on object 1");
      //         break;

      //       // case object2:
      //       //   console.log("click on object 2");
      //       //   break;

      //       // case object3:
      //       //   console.log("click on object 3");
      //       //   break;
      //     }
      //   }
      // });
      // window.addEventListener("touchend", () => {
      //   // console.log("touch1");
      //   // console.log("current3 es, ", this.currentIntersect);
      //   // this.activo = false;
      //   if (this.currentIntersect) {
      //     // alert("click12");
      //     switch (this.currentIntersect.object.name) {
      //       case "":
      //         // console.log("click on object 1");
      //         break;

      //       // case object2:
      //       //   console.log("click on object 2");
      //       //   break;

      //       // case object3:
      //       //   console.log("click on object 3");
      //       //   break;
      //     }
      //   }
      // });
      window.addEventListener("resize", () => {
        // this.isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
        // let estadoTouch = "ontouchcancel" in window;
        // console.log("estadoTouch es, ", estadoTouch);

        if (window.matchMedia("(pointer: coarse)").matches) {
          // touchscreen
          this.isTouch = true;
        } else {
          this.isTouch = false;
        }
        // console.log("this.isTouch  es, ", this.isTouch);
      });
    }

    pick(normalizedPosition, scene, camera) {
      // console.log("this estado es, ", this.estado);

      this.scene = scene;
      // restore the color if there is a picked object
      if (this.pickedObject) {
        this.pickedObject.material.emissive.setHex(this.pickedObjectSavedColor);
        this.pickedObject = undefined;
      }
      if (
        parseFloat(normalizedPosition.x) === 0 &&
        parseFloat(normalizedPosition.y) === 0
      ) {
        return;
      }
      // console.log("normalize es, ", normalizedPosition);
      // cast a ray through the frustum
      this.raycaster.setFromCamera(normalizedPosition, camera);
      // get the list of objects the ray intersected
      let intersectedObjects = this.raycaster.intersectObjects(scene.children);
      if (intersectedObjects.length) {
        if (!this.currentIntersect) {
          if (this.isTouch) {
            // this.estado = this.estado + 1;
            // if (this.activo) return;
            // if (this.estado === 0) return;
            // this.timer = this.timer + 1;
            // console.log("current111 es", intersectedObjects[0].object.name);
            switch (true) {
              case intersectedObjects[0].object.name.includes("lente21"):
                // console.log("this activo es, ", this.activo);
                if (this.activo) return;
                this.activo = true;
                // this.setState({ modal: true });
                // this.state.modal = true;
                // this.handleShow("lente21");
                // this.getModal();
                // this.stateModal = true;
                // refFuncionModal1.current();
                // funcionPrueba1();
                // this.activarModal();
                refFuncionModal1.current();

                // console.log("setState1 es, ", this.state.modal);
                // this.currentIntersect = null;
                normalizedPosition.x = -10000;
                normalizedPosition.y = -10000;

                break;
              case intersectedObjects[0].object.name.includes("lente23"):
                if (this.activo) return;
                // alert("click en lente 23");
                this.activo = true;
                // handleShow("lente23");
                // console.log("click en lente 23");
                // this.stateModal = true;
                refFuncionModal3.current();
                // funcionPrueba3();

                // this.currentIntersect = null;
                normalizedPosition.x = -10000;
                normalizedPosition.y = -10000;

                break;
              case intersectedObjects[0].object.name.includes("lente22"):
                if (this.activo) return;
                // alert("click en lente 22");
                this.activo = true;
                handleShow("lente22");
                // this.stateModal = true;
                refFuncionModal2.current();
                // funcionPrueba2();
                // this.currentIntersect = null;
                normalizedPosition.x = -10000;
                normalizedPosition.y = -10000;

                break;
            }
          }
          // console.log("resultado es, ", this.isTouch);

          // console.log("mouse enter");
          document.body.style.cursor = "pointer";
          // document.body.style.msTouchAction = "none";
          // evento.preventDefault();
        }
        // console.log("intersect es, ", intersectedObjects[0]);
        this.currentIntersect = intersectedObjects[0];
      } else {
        if (this.currentIntersect) {
          this.timer = 0;
          this.estado = 0;
          // console.log("mouse leave");
          this.activo = false;
          document.body.style.cursor = "default";
        }

        this.currentIntersect = null;
      }
      // console.log("intersected objects es, ", intersectedObjects);
      if (intersectedObjects.length) {
        // console.log("color1");
        // pick the first object. It's the closest one
        this.pickedObject = intersectedObjects[0].object;
        // save its color
        this.pickedObjectSavedColor =
          this.pickedObject.material.emissive.getHex();
        // set its emissive color to flashing red/yellow
        // this.pickedObject.material.emissive.setHex(
        //   (time * 8) % 2 > 1 ? 0xffff00 : 0xff0000
        // );
        this.pickedObject.material.emissive.setHex(0x640000);
        // document.body.style.pointerEvents = "none";
      } else {
        // document.body.style.pointerEvents = "auto";
      }
    }
  }
  // }, [refTick2.current]);
  /**
   *
   *
   *
   * Class PickHelper Select
   *
   *
   *
   */
  class PickHelperSelect {
    constructor() {
      // console.log("props son, ", props);
      // this.props.funcionModal = this.props.funcionModal.bind(this);

      this.raycaster = new THREE.Raycaster();
      this.pickedObject = null;
      this.pickedObjectSavedColor = 0;
      this.currentIntersect = null;
      this.scene = undefined;
      this.timer = 0;
      this.activo = false;
      this.estado = 0;
      this.pick = this.pick.bind(this);
      // this.handleShow = this.handleShow.bind(this);
      this.stateModal = false;
      // this.isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
      if (window.matchMedia("(pointer: coarse)").matches) {
        // touchscreen
        this.isTouch = true;
      } else {
        this.isTouch = false;
      }
    }

    // handleShow = (lente) => {
    //   // this.setState({ modal: true });
    //   this.props.funcionModal("lente21");
    //   console.log("handle class");
    // };
    get getModal() {
      // console.log("entra en getModal");
      // setModalPick(true);
      // this.setState({ modal: true });
      return this.stateModal;
    }
    setModal1(param) {
      // console.log("se ejecuta setmodal1");
      this.stateModal = param;
    }

    // componentWillMount() {
    //   this.pick = this.pick.bind(this);
    // }
    // click() {
    //   console.log("se ejecuta funcion click");
    //   window.addEventListener("click", () => {
    //     console.log("click");
    //     console.log("current2 es, ", this.currentIntersect);

    //     if (this.currentIntersect) {
    //       switch (this.currentIntersect.object.name) {
    //         case "":
    //           alert("click");
    //           console.log("click on object 1");
    //           break;

    //         // case object2:
    //         //   console.log("click on object 2");
    //         //   break;

    //         // case object3:
    //         //   console.log("click on object 3");
    //         //   break;
    //       }
    //     }
    //   });
    // }

    click() {
      // console.log("se ejecuta funcion click");
      window.addEventListener("click", () => {
        // console.log("click");
        // console.log("current2 es, ", this.currentIntersect);

        if (this.currentIntersect) {
          // alert("click11");
          // console.log("this.currentIntersect", this.currentIntersect);
          switch (true) {
            case this.currentIntersect.object.name.includes("joe"):
              // alert("Joe!");
              refMatilda.current.visible = false;
              refJoe.current.visible = true;
              funcionLentesJoe();
              break;
            case this.currentIntersect.object.name.includes("matilda"):
              // alert("Matilda!");
              refMatilda.current.visible = true;
              refJoe.current.visible = false;
              funcionLentesMatilda();
              break;
          }
        }
      });
      // window.addEventListener("resize", () => {
      //   // console.log("click");
      //   // console.log("current2 es, ", this.currentIntersect);

      //   this.isTouch =
      //     "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
      //   // console.log("resize es, ", this.isTouch);
      // });
      // window.addEventListener("touchstart", () => {
      //   // console.log("touch1");
      //   // console.log("current3 es, ", this.currentIntersect);

      //   if (this.currentIntersect) {
      //     // this.activo = true;
      //     // alert("click12");
      //     switch (this.currentIntersect.object.name) {
      //       case "":
      //         // console.log("click on object 1");
      //         break;

      //       // case object2:
      //       //   console.log("click on object 2");
      //       //   break;

      //       // case object3:
      //       //   console.log("click on object 3");
      //       //   break;
      //     }
      //   }
      // });
      // window.addEventListener("touchend", () => {
      //   // console.log("touch1");
      //   // console.log("current3 es, ", this.currentIntersect);
      //   // this.activo = false;
      //   if (this.currentIntersect) {
      //     // alert("click12");
      //     switch (this.currentIntersect.object.name) {
      //       case "":
      //         // console.log("click on object 1");
      //         break;

      //       // case object2:
      //       //   console.log("click on object 2");
      //       //   break;

      //       // case object3:
      //       //   console.log("click on object 3");
      //       //   break;
      //     }
      //   }
      // });
      window.addEventListener("resize", () => {
        // this.isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
        // let estadoTouch = "ontouchcancel" in window;
        // console.log("estadoTouch es, ", estadoTouch);

        if (window.matchMedia("(pointer: coarse)").matches) {
          // touchscreen
          this.isTouch = true;
        } else {
          this.isTouch = false;
        }
        // console.log("this.isTouch  es, ", this.isTouch);
      });
    }

    pick(normalizedPosition, scene, camera) {
      // console.log("this estado es, ", this.estado);

      this.scene = scene;
      // restore the color if there is a picked object
      if (this.pickedObject) {
        this.pickedObject.material.emissive.setHex(this.pickedObjectSavedColor);
        this.pickedObject = undefined;
      }
      if (
        parseFloat(normalizedPosition.x) === 0 &&
        parseFloat(normalizedPosition.y) === 0
      ) {
        return;
      }
      // console.log("normalize es, ", normalizedPosition);
      // cast a ray through the frustum
      this.raycaster.setFromCamera(normalizedPosition, camera);
      // get the list of objects the ray intersected
      let intersectedObjects = this.raycaster.intersectObjects(scene.children);
      if (intersectedObjects.length) {
        if (!this.currentIntersect) {
          if (this.isTouch) {
            // this.estado = this.estado + 1;
            // if (this.activo) return;
            // if (this.estado === 0) return;
            // this.timer = this.timer + 1;
            // console.log("current111 es", intersectedObjects[0].object.name);
            switch (true) {
              case intersectedObjects[0].object.name.includes("matilda"):
                // console.log("aca esta el problema");
                // console.log("this activo es, ", this.activo);
                if (this.activo) return;
                this.activo = true;
                // this.setState({ modal: true });
                // this.state.modal = true;
                // this.handleShow("lente21");
                // this.getModal();
                // this.stateModal = true;
                refMatilda.current.visible = true;
                refJoe.current.visible = false;
                // console.log("setState1 es, ", this.state.modal);
                // this.currentIntersect = null;
                normalizedPosition.x = -10000;
                normalizedPosition.y = -10000;
                funcionLentesMatilda();

                break;
              case intersectedObjects[0].object.name.includes("joe"):
                if (this.activo) return;
                // alert("click en lente 23");
                this.activo = true;
                // handleShow("lente23");
                // this.stateModal = true;
                refMatilda.current.visible = false;
                refJoe.current.visible = true;
                // this.currentIntersect = null;
                normalizedPosition.x = -10000;
                normalizedPosition.y = -10000;
                funcionLentesJoe();

                break;
              case intersectedObjects[0].object.name.includes("lente22"):
                if (this.activo) return;
                // alert("click en lente 22");
                this.activo = true;
                handleShow("lente22");
                this.stateModal = true;
                // this.currentIntersect = null;
                normalizedPosition.x = -10000;
                normalizedPosition.y = -10000;

                break;
            }
          }
          // console.log("resultado es, ", this.isTouch);

          // console.log("mouse enter");
          document.body.style.cursor = "pointer";
          // document.body.style.msTouchAction = "none";
          // evento.preventDefault();
        }
        // console.log("intersect es, ", intersectedObjects[0]);
        this.currentIntersect = intersectedObjects[0];
      } else {
        if (this.currentIntersect) {
          this.timer = 0;
          this.estado = 0;
          // console.log("mouse leave");
          this.activo = false;
          document.body.style.cursor = "default";
        }

        this.currentIntersect = null;
      }
      // console.log("intersected objects es, ", intersectedObjects);
      if (intersectedObjects.length) {
        // console.log("color11");
        // console.log("intersectedObjects.length", intersectedObjects);
        this.currentIntersect = intersectedObjects[0];
        // pick the first object. It's the closest one
        this.pickedObject = intersectedObjects[0].object;
        // save its color
        this.pickedObjectSavedColor =
          this.pickedObject.material.emissive.getHex();
        // set its emissive color to flashing red/yellow
        // this.pickedObject.material.emissive.setHex(
        //   (time * 8) % 2 > 1 ? 0xffff00 : 0xff0000
        // );
        // this.pickedObject.material.emissive.setHex(0x640000);
        // document.body.style.pointerEvents = "none";
      } else {
        // document.body.style.pointerEvents = "auto";
      }
    }
  }
  // const setRef = useCallback((node) => {
  //   if (refCarousel2.current) {
  //     // Make sure to cleanup any events/references added to the last instance
  //   }
  //   console.log("node es, ", node);
  //   if (node !== null) {
  //     // Check if a node is actually passed. Otherwise node would be null.
  //     // You can now do what you need to, addEventListeners, measure, etc.
  //     refCarousel2.current = node;
  //     console.log("existe ref, ", refCarousel2.current);
  //   }
  const setRef = useCallback(async (node) => {
    if (node) {
      const [sceneCarousel1, divCarousel1] =
        generarSceneCarousel("scenecarousel1");
      refCarousel1.current = node;
      refCarousel1.current.appendChild(divCarousel1);
      // const lentes231 = await gltf.loadAsync("./lente23.gltf");
      refSceneCarousel1.current = sceneCarousel1;

      // const lentePrueba1 = lentes231.scene;
      // refModelCarousel1.current = lentes231.scene;
      // refModelCarousel1.current.scale.set(0.14, 0.14, 0.14);
      // refModelCarousel1.current.position.z = 0.18;
      // refModelCarousel1.current.position.y = 0.22;
      // refSceneCarousel1.current.add(refModelCarousel1.current);
      scenes.push(refSceneCarousel1.current);
      // refPickHelperCarousel1.current = new PickHelper2();
      // refPickHelperCarousel1.current.click();
    }
    // console.log("node es, ", refCarousel1.current);
  }, []);
  const setRef2 = useCallback((node) => {
    if (node) {
      const [sceneCarousel2, divCarousel2] =
        generarSceneCarousel("scenecarousel2");
      refCarousel2.current = node;
      refCarousel2.current.appendChild(divCarousel2);
      refSceneCarousel2.current = sceneCarousel2;
      scenes.push(refSceneCarousel2.current);
      // refPickHelperCarousel2.current = new PickHelper2();
      // refPickHelperCarousel2.current.click();
    }
    // console.log("node2 es, ", refCarousel2.current);
  }, []);
  const setRef3 = useCallback((node) => {
    if (node) {
      const [sceneCarousel2, divCarousel2] =
        generarSceneCarousel("scenecarousel3");
      refCarousel3.current = node;
      refCarousel3.current.appendChild(divCarousel2);
      refSceneCarousel3.current = sceneCarousel2;
      scenes.push(refSceneCarousel3.current);
      // refPickHelperCarousel3.current = new PickHelper2();
      // refPickHelperCarousel3.current.click();
    }
    // console.log("node es, ", refCarousel2.current);
  }, []);
  //   // Save a reference to the node
  // }, []);
  useEffect(() => {
    // console.log("existe ref en useeffect, ", refCarousel2.current);
  }, []);

  const principal = async () => {
    const canvas = document.getElementById("c");
    // const canvas3 = document.getElementById("canvas-modal");
    const canvasCorgi = document.getElementById("canvas-corgi");
    // const canvas = document.querySelector("canvas.webgl");
    // const canvas = document.querySelector("canvas.webgl");
    // Scene
    // const scene = new THREE.Scene();

    // const gui = new dat.GUI();

    const debugObject = {};
    // dracoLoader.setDecoderPath(
    //   "https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/js/libs/draco/"
    // ); // use a full url path
    // const dracoLoader = new DRACOLoader();
    // dracoLoader.setDecoderPath("/draco/"); // use a full url path
    // const gltf = new GLTFLoader();
    // gltf.setDRACOLoader(dracoLoader);
    /**
     * Objects
     */

    // const content = document.getElementById("content2");
    const content3 = document.getElementById("content3");
    const contentDiv1 = document.getElementById("content-div1");
    const contentCorgi = document.getElementById("content-corgi");
    // console.log("div content 1, ", contentDiv1);
    const [scene, div1] = generarScene("scene");
    const [scene2, div2] = generarScene("scene2");
    const [scene3, div3] = generarScene("scene3");
    ///Person Joe
    const [scenePerson1, divPerson1] = generarScenePerson("sceneperson1");
    // content3.appendChild(divPerson1);

    ///Lente smart
    var ele = document.querySelector("#columna-2");
    ele.appendChild(divPerson1);
    ele.appendChild(textoRotate.current);
    // ele.parentNode.insertBefore(divPerson1, ele);
    ///////////Items que van pasando
    const [sceneCarousel1, divCarousel1] = generarScene("scenecarousel");
    // console.log("ref carousel es, ", refCarousel2.current);
    // refCarousel2.current.appendChild(divCarousel1);
    scenes.push(sceneCarousel1);

    // insert before the .div2 element by getting
    // its parent node
    // refSceneModal1 = scene2;
    // refDivModal1.current = divModal1;
    //////////Scene Modal lentes
    //////////////Corgi
    const [sceneCorgi, divCorgi] = generarSceneCorgi(
      "scenecorgi",
      refPersonaje
    );
    contentCorgi.appendChild(divCorgi);
    scenes2.push(sceneCorgi);
    // console.time("Modelo3d");
    // const corgi = await gltf.loadAsync("./corgi1.glb");
    // corgi.scene.scale.set(0.4, 0.4, 0.4);
    // sceneCorgi.add(corgi.scene);
    const [sceneSmart, divSmart] = generarSmart("scenesmart");
    scenes.push(sceneSmart);
    // console.time("corgi");
    const corgi = await gltf.loadAsync("./modelo2/untitled.gltf");
    // console.timeEnd("corgi");
    refCorgi.current = corgi.scene;
    refSmart.current.appendChild(divSmart);
    refCorgi.current.position.y = -0.18;
    // console.time("lenteSmart");
    const smart2 = await gltf.loadAsync("./lente-smart/untitled.gltf");
    // const lentes = await gltf.loadAsync("./robot1.gltf");
    const smart = smart2.scene;
    // refModel21.current.scale.set(0.2, 0.2, 0.2);
    smart.scale.set(0.7, 0.7, 0.7);
    smart.position.x = 0;
    smart.position.y = -0.1;
    smart.rotation.z = Math.PI * 1.75;
    sceneSmart.add(smart);
    // console.timeEnd("lenteSmart");

    /**
     *
     *
     *
     *
     *
     * Texto
     *
     *
     *
     *
     *
     *
     */
    const [sceneTexto, divTexto] = generarSceneTexto("scenetexto");
    scenes.push(sceneTexto);
    // const texto1 = await gltf.loadAsync("./textos/textoBlender.gltf");
    // const lentes = await gltf.loadAsync("./robot1.gltf");
    // const texto = texto1.scene;
    // refModel21.current.scale.set(0.2, 0.2, 0.2);
    // texto.scale.set(0.8, 0.8, 0.8);
    // smart.position.x = 0;
    // smart.rotation.z = Math.PI * 1.75;
    /**
     *
     *
     *
     * Texto 3d
     *
     *
     *
     *
     */
    const fontLoader = new FontLoader(manager);
    const font = await fontLoader.loadAsync("fonts/montserrat.json");
    // console.log("font es, ", font);
    let geometry = new TextGeometry(
      `
      SMART
    GLASSES
    
    `,
      {
        font: font,

        size: 10,
        height: 5,
        curveSegments: 3,

        bevelThickness: 1,
        bevelSize: 0.1,
        bevelEnabled: true,
      }
    );

    geometry.center();

    const tessellateModifier = new TessellateModifier(8, 6);

    geometry = tessellateModifier.modify(geometry);

    //

    const numFaces = geometry.attributes.position.count / 3;

    const colors = new Float32Array(numFaces * 3 * 3);
    const displacement = new Float32Array(numFaces * 3 * 3);

    const color = new THREE.Color(0x640000);

    for (let f = 0; f < numFaces; f++) {
      const index = 9 * f;

      const h = 0.2 * Math.random();
      const s = 0.5 + 0.5 * Math.random();
      const l = 0.5 + 0.5 * Math.random();

      // color.setHSL(h, s, l);
      const d = 10 * (0.5 - Math.random());
      for (let i = 0; i < 3; i++) {
        colors[index + 3 * i] = color.r;
        colors[index + 3 * i + 1] = color.g;
        colors[index + 3 * i + 2] = color.b;
        // colors[index + 3 * i] = 0.52;
        // colors[index + 3 * i + 1] = 0.8;
        // colors[index + 3 * i + 2] = 0.153;

        displacement[index + 3 * i] = d;
        displacement[index + 3 * i + 1] = d;
        displacement[index + 3 * i + 2] = d;
      }
    }
    // console.log("colors es, ", colors);
    geometry.setAttribute("customColor", new THREE.BufferAttribute(colors, 3));
    geometry.setAttribute(
      "displacement",
      new THREE.BufferAttribute(displacement, 3)
    );

    //

    const uniforms = {
      amplitude: { value: 0.0 },
    };

    const shaderMaterial = new THREE.ShaderMaterial({
      // wireframe:true,
      // transparent: true,
      uniforms: uniforms,
      // vertexShader: document.getElementById( 'vertexshader' ).textContent,
      // fragmentShader: document.getElementById( 'fragmentshader' ).textContent
      vertexShader: `
      uniform float amplitude;

			attribute vec3 customColor;
			attribute vec3 displacement;

			varying vec3 vNormal;
			varying vec3 vColor;

			void main() {

				vNormal = normal;
				vColor = customColor;

				vec3 newPosition = position + normal * amplitude * displacement;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( newPosition, 1.0 );

			}
  `,
      fragmentShader: `
  varying vec3 vNormal;
  varying vec3 vColor;

  void main() {

    const float ambient = 0.4;

    vec3 light = vec3( 1.0 );
    light = normalize( light );

    float directional = max( dot( vNormal, light ), 0.0 );

    gl_FragColor = vec4( ( directional + ambient ) * vColor, 1.0 );

  }
  `,
    });
    shaderMaterial.uniformsNeedUpdate = true;
    // uniforms.amplitude.needsUpdate = true;

    //

    const meshTexto = new THREE.Mesh(geometry, shaderMaterial);
    // meshTexto.scale.set(0.1, 0.1, 0.1);
    // meshTexto.position.y = 90;
    meshTexto.position.y = 0;
    meshTexto.position.x = -100;
    meshTexto.rotation.y = Math.PI * 0.12;
    // meshTexto.position.y = 60;
    sceneTexto.add(meshTexto);
    if (window.innerWidth < 415) {
      meshTexto.scale.set(1.2, 1.2, 1.2);
    }

    /*
    
    
    
    
  Fin Texto 3d
    
    
    
    
    */
    // sceneSmart.add(texto3d);
    // const fontLoader = new FontLoader();

    // fontLoader.load("/fonts/helvetiker_regular.typeface.json", (font) => {
    //   // Material
    //   // const material = new THREE.MeshMatcapMaterial();
    //   const material = new THREE.MeshBasicMaterial({ color: "#000000" });
    //   // const material = new THREE.MeshBasicMaterial({ wireframe: true });
    //   // Text
    //   const textGeometry = new TextGeometry("SMART GLASSES", {
    //     font: font,
    //     size: 0.1,
    //     height: 0.01,
    //     curveSegments: 12,
    //     bevelEnabled: true,
    //     bevelThickness: 0.01,
    //     bevelSize: 0.001,
    //     bevelOffset: 0,
    //     bevelSegments: 5,
    //   });idleBailarMobile
    //   textGeometry.center();

    //   const text = new THREE.Mesh(textGeometry, material);
    //   sceneTexto.add(text);
    // });

    refTexto.current.appendChild(divTexto);
    setMostrarBoton(true);
    const anim = new FBXLoader(manager);
    anim.setPath("./modelo/");
    let mixer;
    let walking;
    let turnLeft;
    let stand1;
    let stand2;
    let idleBailar;
    let idleBailarMobile;
    let idleDePie1;
    let idleDePie2;
    let idleClonePie1;
    let standClone1;
    let idleGirarIzquierda90;
    let idleCaminar;
    let idleCloneCaminar1;
    let walkingClone1;
    let standClone2;
    let idleClonePie2;
    let turnRight;
    let idleCloneGirarDerecha90;
    let bailarClone1;
    let idleCloneBailar1;
    let standClone3;
    let idleClonePie3;
    let standClone4;
    let idleClonePie4;
    let idleCloneGirarIzquierda2;
    let turnLeftClone2;
    let bailarClone2;
    let idleCloneBailar2;
    let idleClonePie5;
    let standClone5;
    let idleClonePie6;
    let standClone6;
    let bailarClone3;
    // console.time("depie");
    // anim.load("depie.fbx", (anim) => {
    //   // console.timeEnd("clone1");
    // });
    let anim2;

    try {
      // anim2 = await anim.loadAsync("depie2.fbx");depieglb
      anim2 = await gltf.loadAsync("./modelo2/animaciones/idle.glb");
      // anim333 = await gltf.loadAsync("./modelo/dancingglb.glb");
    } catch (error) {
      // window.location.reload();
    }
    stand1 = new THREE.AnimationMixer(refCorgi.current);
    // this._mixers.push(m);
    idleDePie1 = stand1.clipAction(anim2.animations[0]);

    // idleDePie1.fadeIn(1);
    idleDePie1.setLoop(THREE.LoopRepeat, 24);
    // idleDePie1.fadeIn(1);
    // idleDePie.duration = 3;
    // idleDePie1.play();
    // console.timeEnd("depie");
    // idleDePie1.fadeIn(1);
    // console.time("clone1");
    ////////Stand2
    standClone1 = new THREE.AnimationMixer(refCorgi.current);
    idleClonePie1 = standClone1.clipAction(anim2.animations[0]);
    idleClonePie1.fadeIn(1);
    //////Stand3
    standClone2 = new THREE.AnimationMixer(refCorgi.current);
    idleClonePie2 = standClone2.clipAction(anim2.animations[0]);
    idleClonePie2.fadeIn(1);
    // idleClonePie2.setLoop(THREE.LoopRepeat, 100);
    standClone3 = new THREE.AnimationMixer(refCorgi.current);
    idleClonePie3 = standClone3.clipAction(anim2.animations[0]);
    idleClonePie3.fadeIn(1);
    //Clone 5
    standClone4 = new THREE.AnimationMixer(refCorgi.current);
    idleClonePie4 = standClone4.clipAction(anim2.animations[0]);
    idleClonePie4.fadeIn(1);
    //Clone 6
    standClone5 = new THREE.AnimationMixer(refCorgi.current);
    idleClonePie5 = standClone5.clipAction(anim2.animations[0]);
    idleClonePie5.fadeIn(1);
    //Clone 7
    standClone6 = new THREE.AnimationMixer(refCorgi.current);
    idleClonePie6 = standClone6.clipAction(anim2.animations[0]);
    // idleClonePie6 = idleClonePie5.clone();
    idleClonePie6.fadeIn(1);

    // anim.load("dancing.fbx", (anim) => {

    // });
    let anim3;
    let anim33;
    let anim333;
    let bailarCloneMobile;
    // anim3 = await anim.loadAsync("dancing5.fbx");
    // anim33 = await anim.loadAsync("dancing5.fbx");
    // anim3 = await anim.loadAsync("dancingcapazanda3.fbx");
    // anim33 = await anim.loadAsync("dancingcapazanda3.fbx");
    // anim333 = await gltf.loadAsync("./modelo/dancingglb.glb");
    anim3 = await gltf.loadAsync("./modelo2/animaciones/dancing.glb");
    // console.log("anim333", anim333);
    bailarCloneMobile = new THREE.AnimationMixer(refCorgi.current);
    idleBailarMobile = bailarCloneMobile.clipAction(anim3.animations[0]);
    idleBailarMobile.setLoop(THREE.LoopRepeat, 1);
    idleBailarMobile.fadeIn(1);
    // console.log("refCorgi.current", refCorgi.current);
    // refCorgi.current.rotation.x = Math.PI * 1.5;
    ///////////
    mixer = new THREE.AnimationMixer(refCorgi.current);
    // console.log("anim3 es", anim3);
    idleBailar = mixer.clipAction(anim3.animations[0]);

    idleBailar.setLoop(THREE.LoopRepeat, 1);
    idleBailar.fadeIn(1);
    //////////////////

    bailarClone1 = new THREE.AnimationMixer(refCorgi.current);
    idleCloneBailar1 = bailarClone1.clipAction(anim3.animations[0]);
    idleCloneBailar1.setLoop(THREE.LoopRepeat, 1);
    idleCloneBailar1.fadeIn(1);
    ////Bailar 3
    bailarClone2 = new THREE.AnimationMixer(refCorgi.current);
    idleCloneBailar2 = bailarClone2.clipAction(anim3.animations[0]);
    idleCloneBailar2.setLoop(THREE.LoopRepeat, 1);
    idleCloneBailar2.fadeIn(1);

    // anim.load("walking.fbx", (anim) => {});
    let anim4;
    try {
      // anim4 = await anim.loadAsync("walking3.fbx");
      anim4 = await gltf.loadAsync("./modelo2/animaciones/walking.glb");
    } catch (error) {
      // window.location.reload();
    }
    // const anim4 = await anim.loadAsync("walking.fbx");
    walking = new THREE.AnimationMixer(refCorgi.current);
    // this._mixers.push(m);
    idleCaminar = walking.clipAction(anim4.animations[0]);
    idleCaminar.fadeIn(1);

    walkingClone1 = new THREE.AnimationMixer(refCorgi.current);
    idleCloneCaminar1 = walkingClone1.clipAction(anim4.animations[0]);
    idleCloneCaminar1.fadeIn(1);
    // anim.load("depie.fbx", (anim) => {
    //   stand2 = new THREE.AnimationMixer(refCorgi.current);
    //   // this._mixers.push(m);
    //   idleDePie2 = stand2.clipAction(anim.animations[0]);
    //   // idleDePie1.fadeIn(1);
    //   // idleDePie.setLoop(THREE.LoopOnce, 30);
    //   // idleDePie.duration = 3;
    //   // idleDePie2.play();
    // });
    // this._scene.add(fbx);
    // refCorgi.current.rotation.y = 3.14 * 1.5;
    // refCorgi.current.scale.set(0.4, 0.4, 0.4);
    // refCorgi.current.rotation.x = Math.PI * 1.5;
    // refCorgi.current.rotation.z = Math.PI * 0.5;
    // sceneCorgi.add(refCorgi.current);

    // sceneCorgi.add(refJoe.current);

    // console.timeEnd("Modelo3d");
    // setTimeout(() => {
    //   console.log("contentModal11 es, ", contentModal1);
    // }, 2000);

    // contentModal1.appendChild(divModal1);
    // content.appendChild(refDivModal1.current);
    // let mixer = new THREE.AnimationMixer(refCorgi.current);
    // const action = mixer.clipAction(corgi.animations[0]);
    ///
    // const mixer = new THREE.AnimationMixer(refCorgi.current);

    // const corgiGirarDerecha = THREE.AnimationUtils.subclip(
    //   corgi.animations[0],
    //   "idle",
    //   1720,
    //   1840
    // );
    // const action = mixer.clipAction(corgiGirarDerecha);
    // action.play();
    // content.appendChild(div1);
    // content.appendChild(div2);
    // content.appendChild(div3);
    // const textoLente1 = document.createElement("p");
    // textoLente1.innerHTML = "Classic";
    // textoLente1.style.className = "text-center";
    // textoLente1.style.fontWeight = "bold";
    refLente1Col.current.appendChild(div1);
    refLente1Col.current.appendChild(textoLente1.current);

    refLente2Col.current.appendChild(div2);
    refLente2Col.current.appendChild(textoLente2.current);

    refLente3Col.current.appendChild(div3);
    refLente3Col.current.appendChild(textoLente3.current);

    scenes.push(scene);
    scenes.push(scene2);
    scenes.push(scene3);
    scenes.push(scenePerson1);
    // scenes.push(refSceneModal1.current);
    const sizes = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    ////////////////////////////////
    /**
     *
     *
     * Personaje Test your glasses
     *
     *
     *
     */
    const person11 = await gltf.loadAsync("./joe.glb");
    // const lentes = await gltf.loadAsync("./robot1.gltf");
    refJoe.current = person11.scene;
    // refModel21.current.scale.set(0.2, 0.2, 0.2);
    refJoe.current.scale.set(70, 70, 70);
    refJoe.current.position.x = 0;
    refJoe.current.visible = true;
    // console.log("Joe es, ", refJoe.current);
    scenePerson1.add(refJoe.current);
    //Hair001 es el pelo
    const temporal2 = (element) => element.name === "Hair001";
    const index2 = refJoe.current.children.findIndex(temporal2);
    refJoeHair.current = refJoe.current.children[index2];
    refJoeHair.current.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#241c11",
    });
    //Skin Joe
    const temporal222 = (element) => element.name === "Joe";
    const index222 = refJoe.current.children.findIndex(temporal222);
    refJoeSkin.current = refJoe.current.children[index222];
    refJoeSkin.current.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#AB755B",
    });
    // pelo.material.metalness = 1;

    refJoe.current.children.forEach(function (item) {
      item.material.metalness = 0.9;
      item.material.roughness = 100;
    });
    /**
     *
     *
     * Joe Clone
     *
     *
     *
     *
     *
     */
    refJoeClone.current = refJoe.current.clone();
    refJoeClone.current.visible = true;
    refJoeClone.current.scale.set(70, 70, 70);
    const [sceneJoeSelect, divJoeSelect] = generarSceneSelect("sceneJoeSelect");

    const temporalHairJoe2 = (element) => element.name === "Hair001";
    const indexHairJoe2 =
      refJoeClone.current.children.findIndex(temporalHairJoe2);
    const joeHairClone = refJoeClone.current.children[indexHairJoe2];
    joeHairClone.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#241c11",
    });
    const temporalSkinJoe2 = (element) => element.name === "Joe";
    const indexSkinJoe2 = refJoe.current.children.findIndex(temporalSkinJoe2);
    const joeSkinClone = refJoeClone.current.children[indexSkinJoe2];
    joeSkinClone.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#AB755B",
    });
    sceneJoeSelect.add(refJoeClone.current);

    refDivSelect.current.appendChild(refTextoSelect.current);
    refDivSelect.current.appendChild(divJoeSelect);

    scenes.push(sceneJoeSelect);
    refJoeClone.current.children.forEach(function (item) {
      item.material.metalness = 0.9;
      item.material.roughness = 100;
    });
    let y = 0;
    refJoeClone.current.children.forEach(function (item) {
      y = y + 1;
      item.name = `joe${y}`;
    });
    // pelo.material.needsUpdate = true;

    /**
     *
     * Personaje Matilda
     *
     *
     */
    const person22 = await gltf.loadAsync("./matilda/matilda.gltf");
    // const lentes = await gltf.loadAsync("./robot1.gltf");
    refMatilda.current = person22.scene;

    // refModel21.current.scale.set(0.2, 0.2, 0.2);
    refMatilda.current.scale.set(70, 70, 70);
    refMatilda.current.position.x = 0;
    refMatilda.current.visible = false;
    // console.log("Matilda es, ", refMatilda.current);

    scenePerson1.add(refMatilda.current);

    /**
     *
     *
     *
     * Clone Matilda
     *
     */
    //Clone Matilda
    // const personMatilda2 = await gltf.loadAsync("./matilda/matilda.gltf");

    // refMatildaClone.current = personMatilda2.scene;
    refMatildaClone.current = refMatilda.current.clone();
    refMatildaClone.current.visible = true;
    refMatildaClone.current.scale.set(70, 70, 70);
    const [sceneMatildaSelect, divMatildaSelect] =
      generarSceneSelect("sceneMatildaSelect");

    const temporalHairMatilda2 = (element) => element.name === "Hair";
    const indexHairMatilda2 =
      refMatildaClone.current.children.findIndex(temporalHairMatilda2);
    const matildaHairClone =
      refMatildaClone.current.children[indexHairMatilda2];
    matildaHairClone.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#241c11",
    });
    const temporalSkinMatilda2 = (element) => element.name === "matilda";
    const indexSkinMatilda2 =
      refMatilda.current.children.findIndex(temporalSkinMatilda2);
    const matildaSkinClone =
      refMatildaClone.current.children[indexSkinMatilda2];
    matildaSkinClone.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#AB755B",
    });
    sceneMatildaSelect.add(refMatildaClone.current);
    refDivSelect.current.appendChild(divMatildaSelect);
    scenes.push(sceneMatildaSelect);
    refMatildaClone.current.children.forEach(function (item) {
      item.material.metalness = 0.9;
      item.material.roughness = 100;
    });
    let j = 0;
    refMatildaClone.current.children.forEach(function (item) {
      j = j + 1;
      item.name = `matilda${j}`;
    });
    //Hair001 es el pelo
    /**
     *
     *
     *
     * Matilda Hair
     *
     *
     *
     *
     */
    const temporalHairMatilda = (element) => element.name === "Hair";
    const indexHairMatilda =
      refMatilda.current.children.findIndex(temporalHairMatilda);
    refMatildaHair.current = refMatilda.current.children[indexHairMatilda];
    refMatildaHair.current.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#241c11",
    });
    // refMatildaHair.current.material.side = THREE.DoubleSide;
    //Matilda Skin
    /**
     *
     *
     * Matilda Skin
     *
     *
     */
    const temporalSkinMatilda = (element) => element.name === "matilda";
    const indexSkinMatilda =
      refMatilda.current.children.findIndex(temporalSkinMatilda);
    refMatildaSkin.current = refMatilda.current.children[indexSkinMatilda];
    refMatildaSkin.current.material = new THREE.MeshStandardMaterial({
      // map: colorTexture,
      color: "#AB755B",
    });
    // pelo2.material.metalness = 1;
    refMatilda.current.children.forEach(function (item) {
      item.material.metalness = 0.9;
      item.material.roughness = 100;
    });

    // pelo.material.needsUpdate = true;
    /**
     * Lentes de personaje
     *
     */
    //Lente 1
    const lentes1Personaje = await gltf.loadAsync("./lentesol1/untitled.gltf");
    // refLente1Personaje.current = lentes1Personaje.scene;
    // refLente1Personaje.current.scale.set(0.39, 0.39, 0.39);
    // refLente1Personaje.current.position.x = 0;
    // refLente1Personaje.current.position.z = 0.1;
    // refLente1Personaje.current.position.y = 0.2;
    // refLente1Personaje.current.visible = true;
    // scenePerson1.add(refLente1Personaje.current);
    //Lente Rayban Prueba
    // const lentes1Personaje = await gltf.loadAsync("./rigel/scene.gltf");
    refLente1Personaje.current = lentes1Personaje.scene;
    // refLente1Personaje.current.scale.set(0.39, 0.39, 0.34);
    // refLente1Personaje.current.position.x = 0;
    // refLente1Personaje.current.position.z = 0.159;
    // refLente1Personaje.current.position.y = 0.17;
    /**
     *
     *
     * Configuracion Joe
     *
     *
     */
    // refLente1Personaje.current.scale.set(0.34, 0.33, 0.315);
    // refLente1Personaje.current.position.x = 0;
    // refLente1Personaje.current.position.z = 0.18;
    // refLente1Personaje.current.position.y = 0.16;
    /**
     *
     *
     * Configuracion Matilda
     */

    // refLente1Personaje.current.scale.set(0.335, 0.34, 0.34);
    // refLente1Personaje.current.position.x = 0;
    // refLente1Personaje.current.position.z = 0.12;
    // refLente1Personaje.current.position.y = 0.125;

    /**
     *
     * Fin configuracion Matilda
     *
     */
    refLente1Personaje.current.visible = true;
    scenePerson1.add(refLente1Personaje.current);
    //Lente 2
    const lentes2Personaje = await gltf.loadAsync("./lentesol2/untitled.gltf");
    refLente2Personaje.current = lentes2Personaje.scene;
    // refLente2Personaje.current.scale.set(0.053, 0.053, 0.053);
    // refLente2Personaje.current.position.x = 0;
    // refLente2Personaje.current.position.z = 0.49;
    // refLente2Personaje.current.position.y = 0.145;
    refLente2Personaje.current.visible = false;
    scenePerson1.add(refLente2Personaje.current);
    //Lente 3
    const lentes3Personaje = await gltf.loadAsync("./lente22/lente22.gltf");
    refLente3Personaje.current = lentes3Personaje.scene;
    // refLente3Personaje.current.scale.set(0.053, 0.053, 0.053);
    // refLente3Personaje.current.position.x = 0;
    // refLente3Personaje.current.position.z = 0.49;
    // refLente3Personaje.current.position.y = 0.145;
    refLente3Personaje.current.visible = false;
    scenePerson1.add(refLente3Personaje.current);
    /**
     *
     * Configuracion Joe
     *
     */
    // refLente2Personaje.current.scale.set(0.052, 0.047, 0.041);
    // refLente2Personaje.current.position.x = 0;
    // refLente2Personaje.current.position.z = 0.49;
    // refLente2Personaje.current.position.y = 0.145;
    /**
     *
     *
     * Fin Personaje
     *
     */
    ///////////////////
    // Models

    /**
     *
     *
     *
     * Lente 1
     *
     *
     *
     */
    let i = 0;
    // const lentes = await gltf.loadAsync("./lente21.gltf");
    const lentes = await gltf.loadAsync("./lentesol1/untitled.gltf");
    // const lentes = await gltf.loadAsync("./robot1.gltf");
    refModel21.current = lentes.scene;
    // console.log("lente 1 es, ", refModel21.current);
    // refModel21.current.scale.set(0.2, 0.2, 0.2);
    // refModel21.current.scale.set(6.4, 6.4, 6.4);
    refModel21.current.scale.set(0.4, 0.4, 0.4);
    refModel21.current.position.x = 0;

    refModel21.current.children.forEach(function (item) {
      i = i + 1;
      item.name = `lente21_${i}`;

      item.children.forEach(function (i2) {
        i = i + 1;
        i2.name = `lente21_${i}`;

        i2.children.forEach(function (i3) {
          i = i + 1;
          i3.name = `lente21_${i}`;
          i3.children.forEach(function (i4) {
            i = i + 1;
            i4.name = `lente21_${i}`;
          });
        });
      });
    });
    scene.add(refModel21.current);

    /**
     *
     *
     *
     * Segundo lente
     *
     *
     */
    const lentes2 = await gltf.loadAsync("./lentesol2/untitled.gltf");
    refModel23.current = lentes2.scene;
    // refModel23.current.scale.set(0.1, 0.1, 0.1);1
    refModel23.current.scale.set(0.06, 0.06, 0.06);
    refModel23.current.position.x = 0;
    // console.log("lente 2 es, ", refModel23.current);

    refModel23.current.children.forEach(function (item) {
      i = i + 1;
      item.name = `lente22_${i}`;
    });
    // console.log("lentes2", lentes2);

    refModel23.current.children.forEach(function (item) {
      i = i + 1;
      item.name = `lente22_${i}`;

      item.children.forEach(function (i2) {
        i = i + 1;
        i2.name = `lente22_${i}`;

        i2.children.forEach(function (i3) {
          i = i + 1;
          i3.name = `lente22_${i}`;
          i3.children.forEach(function (i4) {
            i = i + 1;
            i4.name = `lente22_${i}`;
            i4.children.forEach(function (i5) {
              i = i + 1;
              i5.name = `lente22_${i}`;
            });
          });
        });
      });
    });
    scene2.add(refModel23.current);

    /**
     *
     *
     *
     * Tercer lente
     *
     *
     *
     *
     *
     */
    const lentes3 = await gltf.loadAsync("./lente22/lente22.gltf");
    refModel22.current = lentes3.scene;
    refModel22.current.scale.set(0.055, 0.055, 0.055);
    // refModel22.current.position.x = -0.1;
    refModel22.current.position.y = -0.13;
    // console.log("lente 3 es, ", refModel22.current);
    refModel22.current.children.forEach(function (item) {
      i = i + 1;
      item.name = `lente23_${i}`;

      item.children.forEach(function (i2) {
        i = i + 1;
        i2.name = `lente23_${i}`;

        i2.children.forEach(function (i3) {
          i = i + 1;
          i3.name = `lente23_${i}`;
          i3.children.forEach(function (i4) {
            i = i + 1;
            i4.name = `lente23_${i}`;
            i4.children.forEach(function (i5) {
              i = i + 1;
              i5.name = `lente23_${i}`;
            });
          });
        });
      });
    });
    scene3.add(refModel22.current);
    /*
  
      Lente 1  Carousel
  
      */

    // const lentes2Carousel = await gltf.loadAsync("./lentesol1/untitled.gltf");
    // refModelCarousel1.current = lentes2Carousel.scene;
    refModelCarousel1.current = refLente1Personaje.current.clone();
    refModelCarousel1.current.visible = true;
    refModelCarousel1.current.scale.set(0.4, 0.4, 0.4);
    refModelCarousel1.current.position.x = 0;
    refSceneCarousel1.current.add(refModelCarousel1.current);
    refModelCarousel1.current.children.forEach(function (item) {
      i = i + 1;
      item.name = `lente23_carousel_${i}`;
    });

    /**
     *
     * Lente 2 Carousel
     *
     */
    // const lentes1Carousel = await gltf.loadAsync("./lente22/lente22.gltf");
    // const lentes1Carousel = await gltf.loadAsync("./lentesol2/untitled.gltf");
    // refModelCarousel2.current = lentes1Carousel.scene;

    refModelCarousel2.current = refLente2Personaje.current.clone();
    refModelCarousel2.current.scale.set(0.065, 0.065, 0.065);
    refModelCarousel2.current.visible = true;
    // console.log("refModelCarousel2.current", refModelCarousel2.current);
    // refModelCarousel2.current.scale.set(10, 10, 10);
    refModelCarousel2.current.position.x = 0;
    // refModelCarousel2.current.position.z = -10;
    // console.log("refModelCarousel2.current", refModelCarousel2.current);
    refSceneCarousel2.current.add(refModelCarousel2.current);
    // console.log("refSceneCarousel2.current", refSceneCarousel2.current);

    /**
     *
     * Lente 3 Carousel
     *
     */
    // const lentes3Carousel3 = await gltf.loadAsync("./lente22/lente22.gltf");
    // refModelCarousel3.current = lentes3Carousel3.scene;
    refModelCarousel3.current = refLente3Personaje.current.clone();
    refModelCarousel3.current.visible = true;
    refModelCarousel3.current.scale.set(0.055, 0.055, 0.055);
    refModelCarousel3.current.position.x = 0;
    refModelCarousel3.current.position.y = -0.13;
    // console.log("refModelCarousel2.current", refModelCarousel2.current);
    refSceneCarousel3.current.add(refModelCarousel3.current);
    // console.time("lente21App");
    // const lente21Modal = object1.clone();
    // setModel(lente21Modal);
    // console.timeEnd("lente21App");
    /////////Scene Modal 1
    // const lentesModal1 = await gltf.loadAsync("./lente21.gltf");
    // const objectModal1 = lentesModal1.scene;
    // objectModal1.scale.set(6.4, 6.4, 6.4);
    // objectModal1.position.x = 0;
    // sceneModal1.add(objectModal1);

    // console.timeEnd("prueba1");
    // console.time("prueba2");

    // const lentes2 = await gltf.loadAsync("./lente23.gltf");

    // console.time("prueba2");
    /*
  
      Lente en Carousel
  
      */
    // console.time("prueba2");

    //Lente de prueba

    // const lentes231 = await gltf.loadAsync("./lente23.gltf");

    // const lentePrueba1 = lentes231.scene;
    // lentePrueba1.scale.set(0.094, 0.094, 0.094);
    // lentePrueba1.position.z = 0.18;
    // lentePrueba1.position.y = 0.22;
    // lentePrueba1.visible = false;
    // scenePerson1.add(lentePrueba1);
    i = 0;
    // const lentes3 = await gltf.loadAsync("./lente22.gltf");
    // const lentes3 = await gltf.loadAsync("./lente3/scene.gltf");

    // console.timeEnd("prueba3");

    //Lente 10 Smart
    // const lentesSmart = await gltf.loadAsync("./lente10.gltf");
    // const objectSmart = lentesSmart.scene;
    // objectSmart.scale.set(3, 3, 3);
    // objectSmart.position.x = -1;
    // console.log("lente 10 es, ", object2);
    // scene.add(object2);

    // colorTexture.encoding = THREE.sRGBEncoding;
    const textureLoader = new THREE.TextureLoader();

    // Material
    const material = new THREE.MeshToonMaterial({
      color: "red",
    });

    /**
     * Raycaster
     */

    const raycaster = new THREE.Raycaster();
    // const rayOrigin = new THREE.Vector3(-3, 0, 0);
    // const rayDirection = new THREE.Vector3(10, 0, 0);
    // rayDirection.normalize();
    // Objects

    const mesh1 = new THREE.Mesh(
      new THREE.TorusGeometry(1, 0.4, 16, 60),
      material
    );
    const mesh2 = new THREE.Mesh(new THREE.ConeGeometry(1, 2, 32), material);
    const mesh3 = new THREE.Mesh(
      new THREE.TorusKnotGeometry(0.8, 0.35, 100, 16),
      material
    );
    mesh1.position.x = 2;
    mesh2.position.x = -2;
    mesh3.position.x = 2;

    // const object1 = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), material);
    // object1.position.x = 0;
    // object1.position.y = -objectsDistance * 0;
    // scene.add(object1);

    // const sectionMeshes = [mesh1, mesh2, mesh3, mesh4];

    // scene.add(new THREE.AmbientLight(0x040404));
    /**
     *
     *
     * Data Gui
     *
     *
     */

    /**
     * 
     * 
     *Primer lente 


     */
    // gui
    //   .add(refLente1Personaje.current.scale, "x")
    //   .min(-1)
    //   .max(1)
    //   .step(0.0001)
    //   .name("scale x");
    // gui
    //   .add(refLente1Personaje.current.scale, "y")
    //   .min(-1)
    //   .max(1)
    //   .step(0.0001)
    //   .name("scale y");
    // gui
    //   .add(refLente1Personaje.current.scale, "z")
    //   .min(-1)
    //   .max(1)
    //   .step(0.0001)
    //   .name("scale z");
    // gui
    //   .add(refLente1Personaje.current.position, "y")
    //   .min(-1)
    //   .max(1)
    //   .step(0.0001)
    //   .name("position y");
    // gui
    //   .add(refLente1Personaje.current.position, "z")
    //   .min(-1)
    //   .max(1)
    //   .step(0.0001)
    //   .name("position z");

    /**
     * 
     * 
     *Segundo lente 


     */
    // gui
    //   .add(refLente2Personaje.current.scale, "x")
    //   .min(0)
    //   .max(0.3)
    //   .step(0.0001)
    //   .name("scale x");
    // gui
    //   .add(refLente2Personaje.current.scale, "y")
    //   .min(0)
    //   .max(0.3)
    //   .step(0.0001)
    //   .name("scale y");
    // gui
    //   .add(refLente2Personaje.current.scale, "z")
    //   .min(-1)
    //   .max(0.3)
    //   .step(0.0001)
    //   .name("scale z");

    // gui
    //   .add(refLente2Personaje.current.position, "y")
    //   .min(-1)
    //   .max(1)
    //   .step(0.0001)
    //   .name("position y");
    // gui
    //   .add(refLente2Personaje.current.position, "z")
    //   .min(-1)
    //   .max(1)
    //   .step(0.0001)
    //   .name("position z");
    /**
     * 
     * 
     *Tercer lente 


     */
    // gui
    //   .add(refLente3Personaje.current.scale, "x")
    //   .min(0)
    //   .max(0.3)
    //   .step(0.0001)
    //   .name("scale x");
    // gui
    //   .add(refLente3Personaje.current.scale, "y")
    //   .min(0)
    //   .max(0.3)
    //   .step(0.0001)
    //   .name("scale y");
    // gui
    //   .add(refLente3Personaje.current.scale, "z")
    //   .min(-10)
    //   .max(2)
    //   .step(0.0001)
    //   .name("scale z");

    // gui
    //   .add(refLente3Personaje.current.position, "y")
    //   .min(-10)
    //   .max(1)
    //   .step(0.0001)
    //   .name("position y");
    // gui
    //   .add(refLente3Personaje.current.position, "z")
    //   .min(-10)
    //   .max(1)
    //   .step(0.0001)
    //   .name("position z");

    /**
     *
     *
     * Prueba lente carousel
     *
     *
     */
    // gui
    //   .add(refModelCarousel2.current.position, "z")
    //   .min(-10)
    //   .max(30)
    //   .step(0.0001)
    //   .name("scale carousel position z");
    // gui
    //   .add(refModelCarousel2.current.scale, "x")
    //   .min(0)
    //   .max(30)
    //   .step(0.0001)
    //   .name("scale carousel x");
    // gui
    //   .add(refModelCarousel2.current.scale, "y")
    //   .min(0)
    //   .max(30)
    //   .step(0.0001)
    //   .name("scale carousel y");
    // gui
    //   .add(refModelCarousel2.current.scale, "z")
    //   .min(0)
    //   .max(30)
    //   .step(0.0001)
    //   .name("scale carousel z");
    // gui
    //   .add(sceneCorgi.userData.camera.rotation, "y")
    //   .min(-10)
    //   .max(10)
    //   .step(0.001)
    //   .name("camera y");
    // gui
    //   .add(refCorgi.current.rotation, "y")
    //   .min(-10)
    //   .max(10)
    //   .step(0.001)
    //   .name("corgi y");
    // gui
    //   .add(refCorgi.current.rotation, "x")
    //   .min(-10)
    //   .max(10)
    //   .step(0.001)
    //   .name("corgi x");
    // gui
    //   .add(refPersonaje.current.style, "margin-left")
    //   .min(-10)
    //   .max(10)
    //   .step(0.001)
    //   .name("corgi div");

    // refCorgi.current.rotation.x = Math.PI * 0.5;
    // gui
    //   .add(directionalLight.position, "x")
    //   .min(-5)
    //   .max(5)
    //   .step(0.001)
    //   .name("lightX");
    // gui
    //   .add(directionalLight.position, "y")
    //   .min(-5)
    //   .max(5)
    //   .step(0.001)
    //   .name("lightY");
    // gui
    //   .add(directionalLight.position, "z")
    //   .min(-5)
    //   .max(5)
    //   .step(0.001)
    //   .name("lightZ");
    const funcionesGsap = () => {
      // refPersonaje.current.style.left = "0px";
      // console.log("entra en funcion gsap1");
      if (refGsap1.current) {
        refGsap1.current.pause();
      }
      if (refGsap2.current) {
        refGsap2.current.pause();
      }
      if (refGsap3.current) {
        refGsap3.current.pause();
      }
      if (refGsap4.current) {
        refGsap4.current.pause();
      }
      if (refGsap5.current) {
        refGsap5.current.pause();
      }
      if (refGsap6.current) {
        refGsap6.current.pause();
      }
      if (refGsap7.current) {
        refGsap7.current.pause();
      }
      if (refGsap8.current) {
        refGsap8.current.pause();
      }
      if (refGsap9.current) {
        refGsap9.current.pause();
      }
      idleBailarMobile.stop();
      idleBailar.stop();
      idleCaminar.stop();
      idleCloneBailar2.stop();
      idleCaminar.stop();
      idleCloneBailar1.stop();
      idleClonePie1.stop();
      refPrimerAnimacion.current.play().reset();
      refPrimerAnimacion.current.clampWhenFinished = true;
      refPrimerAnimacion.current.fadeIn(1);
      refPrimerAnimacion.current.setLoop(THREE.LoopRepeat, 2);

      // refCorgi.current.position.y = 0;
      refGsap11.current = gsap.to(refPersonaje.current, {
        duration: 0,
        startAt: {
          // left: "-3px",
          // left: temporalNumero,
          //Linea siguiente correcta
          left: "0%",
          top: "0px",
          position: "fixed",
          // width: "500px",
          // height: "500px",
        },
        transform: "rotate(0deg)",
        xPercent: 0,
        left: "0%",
        force3D: true,
        // x: (37 * window.innerWidth) / 100,
        x: 0,
        width: 500,
        height: 500,
        position: "fixed",
        // left: 400,
        // top: "0px",
        ease: "none",
        // ease: "power3.out",
        onComplete: () => {
          // console.log("se movio");
          // gsap.to(refCorgi.current.rotation, {
          //   x: Math.PI * 2,
          //   delay: 0,
          //   onComplete: () => {
          //     setTimeout(() => {
          //       idleBailar.zeroSlopeAtStart = false;
          //       idleBailar.play().reset();
          //       idleBailar.clampWhenFinished = true;
          //       idleBailar.fadeIn(2);
          //     }, 1000);
          //   },
          // });
        },
      });
      funcionPersonajeDesktop();
    };

    let alturaInicial = window.innerHeight;
    let anchoInicial = window.innerWidth;
    const sleep = (ms) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    };
    let variableResize = false;
    window.addEventListener("resize", async () => {
      // await sleep(250);
      // console.log("resize");
      // console.log("pasa aca 2");
      refCorgi.current.rotation.y = Math.PI * 0;
      // refGsap2.current.pause();
      // refGsap3.current.pause();
      // refGsap4.current.pause();
      // refGsap5.current.pause();
      // refGsap6.current.pause();
      // refGsap7.current.pause();
      // refGsap8.current.pause();
      // refGsap9.current.pause();

      // canvas.style.transform = `translateY(${window.scrollY - 3000}px)`;
      canvas.style.transform = `translateY(${window.scrollY - 2300}px)`;
      // canvas.style.transform = `translateY(${window.scrollY}px)`;

      // console.log("webgl info es, ", refRenderer.current.info);

      /**
       *
       *
       *
       * Empieza configuracion
       */
      // console.log("window inner width es, ", window.innerWidth);

      // setEstadoResize(!estadoResize)
      if (window.innerWidth < 768) {
        if (
          alturaInicial === window.innerHeight &&
          anchoInicial !== window.innerWidth
        ) {
          funcionesPersonajeMobile();
          alturaInicial = window.innerHeight;
          anchoInicial = window.innerWidth;
        }
      } else {
        // await sleep(250);
        funcionesGsap();
        alturaInicial = window.innerHeight;
        anchoInicial = window.innerWidth;
      }
      if (window.innerWidth < 415) {
        meshTexto.scale.set(1.2, 1.2, 1.2);
      } else {
        meshTexto.scale.set(1, 1, 1);
      }

      /**
       *
       *
       * Termina configuracion
       *
       *
       *
       */
      // sizes.width = window.innerWidth;
      // sizes.height = window.innerHeight;
      // scenes.forEach(function (scene, index) {
      //   // draw the scene
      //   scene.userData.camera.aspect = sizes.width / sizes.height;
      //   scene.userData.camera.updateProjectionMatrix();
      // });
      // Update camera
      // camera.aspect = sizes.width / sizes.height
      // camera.updateProjectionMatrix()

      // Update renderer
      // refRenderer.current.setSize(sizes.width, sizes.height);
      // refRendererCorgi.current.setSize(sizes.width, sizes.height);
      // Update sizes
      // sizes.width = window.innerWidth;
      // sizes.height = window.innerHeight;
      // // Update camera
      // camera4.aspect = sizes.width / sizes.height;
      // camera4.updateProjectionMatrix();
      // // Update renderer
      // refRenderer.current.setSize(sizes.width, sizes.height);
      // refRenderer.current.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      // const width = canvas.clientWidth;
      // const height = canvas.clientHeight;
      // if (canvas.width !== width || canvas.height !== height) {
      //   refRenderer.current.setSize(width, height, false);
      // }
    });
    /**
     * Click
     */
    /**
     * Mouse
     */

    // window.addEventListener("mousemove", (event) => {
    //   mouse.x = (event.clientX / sizes.width) * 2 - 1;
    //   mouse.y = -(event.clientY / sizes.height) * 2 + 1;
    // });
    // const mouse = new THREE.Vector2();
    const mouse = { x: 0, y: 0 };
    clearPickPosition();
    // let canvasRect = { width: 300, height: 300 }; // start with default size
    let canvasRect = canvas;
    const elem = scene.userData.element;
    function getCanvasRelativePosition(event) {
      // console.log("ref element es, ", refElement.current);
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPosition(event) {
      const pos = getCanvasRelativePosition(event);
      mouse.x = (pos.x / canvasRect.width) * 2 - 1;
      mouse.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
      // mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      // mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    function clearPickPosition() {
      // unlike the mouse which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouse.x = -100000;
      mouse.y = -100000;
    }
    const elementScene1 = scene.userData.element;
    elementScene1.addEventListener("mousemove", setPickPosition);
    elementScene1.addEventListener("mouseout", clearPickPosition);
    elementScene1.addEventListener("mouseleave", clearPickPosition);
    // elementScene1.addEventListener(
    //   "touchstart",
    //   async (event) => {
    //     // prevent the window from scrolling
    //     // event.preventDefault();
    //     // setEvento(event);
    //     // event.sourceCapabilities.firesTouchEvents = false;
    //     // elementScene1.style.touchAction = "none";
    //     // elementScene1.setAttribute("style", "-ms-touch-action: none;");

    //     // console.log("touch start");
    //     // setPickPosition(event.touches[0]);
    //     mouse.x = (event.changedTouches[0].clientX / canvasRect.width) * 2 - 1;
    //     mouse.y =
    //       -(event.changedTouches[0].clientY / canvasRect.height) * 2 + 1;
    //     // await timeout(100);
    //     // event.preventDefault();
    //     // console.log("element1 es, ");
    //   },
    //   // { passive: false }
    //   false
    // );
    // document.body.style.touchAction = "none";
    // document.body.style.pointerEvents = "none";
    function timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    // elementScene1.addEventListener("touchmove", (event) => {
    //   setPickPosition(event.touches[0]);
    //   // event.preventDefault();
    // });

    elementScene1.addEventListener("touchend", async (event) => {
      // await timeout(10);
      // event.preventDefault();

      // console.log("touch end numero uno");
      mouse.x = -100000;
      mouse.y = -100000;
    });
    // elementScene1.addEventListener("touchcancel", () => {
    //   // console.log("touchcancel1");
    // });
    // window.addEventListener("touchend", (event) => {
    //   mouse.x = (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1;
    //   mouse.y = -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1;
    // });
    /////////////////Mouse 2
    // const mouse2 = new THREE.Vector2();
    const elementScene2 = scene2.userData.element;
    const mouse2 = { x: 0, y: 0 };
    function getCanvasRelativePosition2(event) {
      const elem = scene2.userData.element;
      // console.log("ref element es, ", refElement.current);
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPosition2(event) {
      const pos = getCanvasRelativePosition2(event);
      mouse2.x = (pos.x / canvasRect.width) * 2 - 1;
      mouse2.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
    }

    function clearPickPosition2() {
      // unlike the mouse2 which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouse2.x = -100000;
      mouse2.y = -100000;
    }
    elementScene2.addEventListener("mousemove", setPickPosition2);
    elementScene2.addEventListener("mouseout", clearPickPosition2);
    elementScene2.addEventListener("mouseleave", clearPickPosition2);

    // elementScene2.addEventListener(
    //   "touchstart",
    //   (event) => {
    //     // prevent the window from scrolling
    //     // event.preventDefault();
    //     // setPickPosition2(event.changedTouches[0]);
    //     // mouse2.x =
    //     //   (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1;
    //     // mouse2.y =
    //     //   -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1;
    //     // mouse2.x = (event.changedTouches[0].clientX / canvasRect.width) * 2 - 1;
    //     // mouse2.y =
    //     //   -(event.changedTouches[0].clientY / canvasRect.height) * 2 + 1;
    //   },
    //   { passive: false }
    // );

    // elementScene2.addEventListener("touchmove", (event) => {
    //   setPickPosition2(event.touches[0]);
    // });

    // window.addEventListener("touchend", clearPickPosition2);
    elementScene2.addEventListener("touchend", async (event) => {
      // await timeout(10);
      // event.preventDefault();

      // console.log("touch end numero uno");
      mouse2.x = -100000;
      mouse2.y = -100000;
    });
    /////////////////Mouse 3
    // const mouse3 = new THREE.Vector2();
    const elementScene3 = scene3.userData.element;
    const mouse3 = { x: 0, y: 0 };
    clearPickPosition3();
    function getCanvasRelativePosition3(event) {
      const elem = scene3.userData.element;
      // console.log("ref element es, ", refElement.current);
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPosition3(event) {
      const pos = getCanvasRelativePosition3(event);
      mouse3.x = (pos.x / canvasRect.width) * 2 - 1;
      mouse3.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
    }

    function clearPickPosition3() {
      // unlike the mouse3 which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouse3.x = -100000;
      mouse3.y = -100000;
    }
    elementScene3.addEventListener("mousemove", setPickPosition3);
    elementScene3.addEventListener("mouseout", clearPickPosition3);
    elementScene3.addEventListener("mouseleave", clearPickPosition3);

    // elementScene3.addEventListener(
    //   "touchstart",
    //   (event) => {
    //     // prevent the window from scrolling
    //     // event.preventDefault();
    //     // setPickPosition3(event.touches[0]);
    //     // mouse3.x =
    //     //   (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1;
    //     // mouse3.y =
    //     //   -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1;

    //     mouse3.x = (event.changedTouches[0].clientX / canvasRect.width) * 2 - 1;
    //     mouse3.y =
    //       -(event.changedTouches[0].clientY / canvasRect.height) * 2 + 1;
    //     // raycaster.setFromCamera(mouse, camera);
    //   },
    //   { passive: false }
    // );

    // elementScene3.addEventListener("touchmove", (event) => {
    //   setPickPosition3(event.touches[0]);
    // });

    // elementScene3.addEventListener("touchend", clearPickPosition3);
    // elementScene3.addEventListener("touchend", async (event) => {
    //   // await timeout(10);
    //   // event.preventDefault();

    //   // console.log("touch end numero uno");
    //   mouse3.x = -100000;
    //   mouse3.y = -100000;
    // });
    // click = false;
    const mouse4 = { x: 0, y: 0 };
    clearPickPosition();
    // let canvasRect = { width: 300, height: 300 }; // start with default size
    // const elem = scene.userData.element;
    function getCanvasRelativePosition4(event) {
      // console.log("ref element es, ", refElement.current);
      const elem = refSceneCarousel1.current.userData.element;
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPosition4(event) {
      const pos = getCanvasRelativePosition4(event);
      mouse4.x = (pos.x / canvasRect.width) * 2 - 1;
      mouse4.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
      // mouse4.x = (event.clientX / window.innerWidth) * 2 - 1;
      // mouse4.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    function clearPickPosition4() {
      // unlike the mouse4 which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouse4.x = -100000;
      mouse4.y = -100000;
    }
    // const elementScene1 = scene.userData.element;
    const elementScene4 = refSceneCarousel1.current.userData.element;
    elementScene4.addEventListener("mousemove", setPickPosition4);
    elementScene4.addEventListener("mouseout", clearPickPosition4);
    elementScene4.addEventListener("mouseleave", clearPickPosition4);

    /**
     *
     *
     * Mouse 5
     */
    const mouse5 = { x: 0, y: 0 };
    clearPickPosition();
    // let canvasRect = { width: 300, height: 300 }; // start with default size
    // const elem = scene.userData.element;
    function getCanvasRelativePosition5(event) {
      // console.log("ref element es, ", refElement.current);
      const elem = refSceneCarousel2.current.userData.element;
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPosition5(event) {
      const pos = getCanvasRelativePosition5(event);
      mouse5.x = (pos.x / canvasRect.width) * 2 - 1;
      mouse5.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
      // mouse5.x = (event.clientX / window.innerWidth) * 2 - 1;
      // mouse5.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    function clearPickPosition5() {
      // unlike the mouse5 which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouse5.x = -100000;
      mouse5.y = -100000;
    }
    // const elementScene1 = scene.userData.element;
    const elementScene5 = refSceneCarousel2.current.userData.element;
    elementScene5.addEventListener("mousemove", setPickPosition5);
    elementScene5.addEventListener("mouseout", clearPickPosition5);
    elementScene5.addEventListener("mouseleave", clearPickPosition5);

    /**
     *
     *
     * Mouse Matilda select
     *
     *
     *
     */
    const elementSceneMatilda = sceneMatildaSelect.userData.element;
    const mouseMatildaSelect = { x: 0, y: 0 };
    function getCanvasRelativePosition7(event) {
      const elem = sceneMatildaSelect.userData.element;
      // console.log("ref element es, ", refElement.current);
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPosition7(event) {
      const pos = getCanvasRelativePosition7(event);
      mouseMatildaSelect.x = (pos.x / canvasRect.width) * 2 - 1;
      mouseMatildaSelect.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
    }

    function clearPickPosition7() {
      // unlike the mouseMatildaSelect which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouseMatildaSelect.x = -100000;
      mouseMatildaSelect.y = -100000;
    }
    elementSceneMatilda.addEventListener("mousemove", setPickPosition7);
    elementSceneMatilda.addEventListener("mouseout", clearPickPosition7);
    elementSceneMatilda.addEventListener("mouseleave", clearPickPosition7);

    /**
     *
     *
     *
     *
     * Joe Mouse
     */

    const elementSceneJoe = sceneJoeSelect.userData.element;
    const mouseJoeSelect = { x: 0, y: 0 };
    function getCanvasRelativePosition6(event) {
      const elem = sceneJoeSelect.userData.element;
      // console.log("ref element es, ", refElement.current);
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPosition6(event) {
      const pos = getCanvasRelativePosition6(event);
      mouseJoeSelect.x = (pos.x / canvasRect.width) * 2 - 1;
      mouseJoeSelect.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
    }

    function clearPickPosition6() {
      // unlike the mouseJoeSelect which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouseJoeSelect.x = -100000;
      mouseJoeSelect.y = -100000;
    }
    elementSceneJoe.addEventListener("mousemove", setPickPosition6);
    elementSceneJoe.addEventListener("mouseout", clearPickPosition6);
    elementSceneJoe.addEventListener("mouseleave", clearPickPosition6);
    /**
     * Sizes
     */
    // window.addEventListener("resize", () => {
    //   // Update sizes
    //   // console.log("width, ", window.innerWidth);
    //   // sizes.width = window.innerWidth;
    //   // sizes.height = window.innerHeight;
    //   sizes.width = window.innerWidth;
    //   sizes.height = window.innerHeight;
    //   //   if (sizes.width < 500) {
    //   //     mesh1.position.x = 0;
    //   //     mesh2.position.x = 0;
    //   //     mesh3.position.x = 0;
    //   //   }
    //   // if (parseInt(sizes.width) > 1360) {
    //   //   refBotella.current.position.x = -1.3;
    //   //   // console.log("entra en if");
    //   // } else {
    //   //   // console.log("entra en else");
    //   //   refBotella.current.position.x = -1.6;
    //   // }

    //   //En 1360px es -1.6
    //   // const resultado1 = parseInt(window.innerWidth) / 2;
    //   // console.log("resultado 1 es, ", resultado1);
    //   // //680
    //   // const resultado2 = (resultado1 * -4) / 1360;
    //   // console.log("resultado 2 es, ", resultado2);

    //   // refBotella.current.position.x = resultado2;
    //   // Update camera
    //   camera.aspect = sizes.width / sizes.height;
    //   camera.updateProjectionMatrix();

    //   // Update renderer
    //   refRenderer.current.setSize(sizes.width, sizes.height);
    //   refRenderer.current.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    // });
    // Renderer 2
    const mouseCorgi = { x: 0, y: 0 };
    clearPickPositionCorgi();
    // let canvasRect = { width: 300, height: 300 }; // start with default size
    // const elem = scene.userData.element;
    function getCanvasRelativePositionCorgi(event) {
      // console.log("ref element es, ", refElement.current);
      const elem = sceneCorgi.userData.element;
      // const elem = refElement.current;
      const rect = elem.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) * canvasRect.width) / rect.width,
        y: ((event.clientY - rect.top) * canvasRect.height) / rect.height,
      };
    }
    function setPickPositionCorgi(event) {
      const pos = getCanvasRelativePositionCorgi(event);
      mouseCorgi.x = (pos.x / canvasRect.width) * 2 - 1;
      mouseCorgi.y = (pos.y / canvasRect.height) * -2 + 1; // note we flip Y
      // mouseCorgi.x = (event.clientX / window.innerWidth) * 2 - 1;
      // mouseCorgi.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    function clearPickPositionCorgi() {
      // unlike the mouseCorgi which always has a position
      // if the user stops touching the screen we want
      // to stop picking. For now we just pick a value
      // unlikely to pick something
      mouseCorgi.x = -100000;
      mouseCorgi.y = -100000;
    }
    // const elementScene1 = scene.userData.element;
    const elementSceneCorgi = sceneCorgi.userData.element;
    elementSceneCorgi.addEventListener("mousemove", setPickPositionCorgi);
    elementSceneCorgi.addEventListener("mouseout", clearPickPositionCorgi);
    elementSceneCorgi.addEventListener("mouseleave", clearPickPositionCorgi);
    /**
     *
     *
     *
     * Renderer Modal
     *
     *
     */
    // refRenderer2.current = new THREE.WebGLRenderer({
    //   canvas: canvas3,
    //   alpha: true,
    //   antialias: true,
    //   premultipliedAlpha: false,
    // });

    // refRenderer2.current.setScissorTest(false);
    // refRenderer2.current.clear();
    // refRenderer2.current.setScissorTest(true);

    // refRenderer2.current.gammaOutput = true;
    // refRenderer2.current.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    /**
     * Renderer
     */
    // scene.background = new THREE.Color(0x000000);

    // console.log("canvas despues es, ", canvas);
    try {
      refRenderer.current = new THREE.WebGLRenderer({
        canvas: canvas,
        alpha: true,
        antialias: true,
        premultipliedAlpha: false,
        powerPreference: "high-performance",
      });
    } catch (error) {
      setError(true);
    }
    // console.log("funciona1");
    // refRenderer.current.setClearColor(0xffffff);
    refRenderer.current.setScissorTest(false);
    refRenderer.current.clear();
    // canvas.loseContextInNCalls(30);
    // refRenderer.current.setClearColor(0xe0e0e0);
    refRenderer.current.setScissorTest(true);
    // refRenderer.current.setClearColor(0xe0e0e0);
    // canvas.addEventListener(
    //   "webglcontextrestored",
    //   function (event) {
    //     // Do something
    //     console.log("se recupero canvas");
    //     principal();
    //   },
    //   false
    // );
    // canvas.addEventListener(
    //   "webglcontextlost",
    //   function (event) {
    //     console.log("crasheo canvas");
    //     window.cancelAnimationFrame(funcionTick);

    //     event.preventDefault();
    //   },
    //   false
    // );
    const element4 = scene.userData.element;

    // get its position relative to the page's viewport
    const rect = element4.getBoundingClientRect();

    // check if it's offscreen. If so skip it
    // if (
    //   rect.bottom < 0 ||
    //   rect.top > refRenderer.current.domElement.clientHeight ||
    //   rect.right < 0 ||
    //   rect.left > refRenderer.current.domElement.clientWidth
    // ) {
    //   return; // it's off screen
    // }

    // set the viewport
    const width = rect.right - rect.left;
    const height = rect.bottom - rect.top;
    const left = rect.left;
    const bottom = refRenderer.current.domElement.clientHeight - rect.bottom;

    refRenderer.current.setViewport(left, bottom, width, height);
    refRenderer.current.setScissor(left, bottom, width, height);

    const camera4 = scene.userData.camera;

    //camera.aspect = width / height; // not changing in this example
    //camera.updateProjectionMatrix();

    //scene.userData.controls.update();
    // refRenderer.current.render(scene, camera4);
    refRenderer.current.physicallyCorrectLights = true;
    refRenderer.current.toneMapping = THREE.ACESFilmicToneMapping;
    // refRenderer.current.toneMapping = THREE.ReinhardToneMapping;
    refRenderer.current.toneMappingExposure = 1;
    refRenderer.current.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    //Con el sRGB no se veia bien
    // refRenderer.current.outputEncoding = THREE.sRGBEncoding;
    // refRenderer.current.outputEncoding = THREE.LinearEncoding;

    refRenderer.current.shadowMap.enabled = true;
    refRenderer.current.shadowMap.type = THREE.PCFSoftShadowMap;
    refRenderer.current.setSize(canvas.clientWidth, canvas.clientHeight, false);
    // refRenderer.current.gammaOutput = true;
    // refRenderer.current.autoClear = false;
    // refRenderer.current.setClearColor(0xffffff);
    /**
     * Renderer Corgi
     *
     */
    try {
      refRendererCorgi.current = new THREE.WebGLRenderer({
        canvas: canvasCorgi,
        alpha: true,
        antialias: true,
        premultipliedAlpha: false,
      });
    } catch (error) {
      setError(true);
    }
    refRendererCorgi.current.clear();
    refRendererCorgi.current.outputEncoding = THREE.sRGBEncoding;

    // refRendererCorgi.current.setClearColor(0xe0e0e0);
    // canvas.style.transform = `translateY(${window.scrollY}px)`;
    // console.log("funciona1");
    // refRenderer.current.setClearColor(0xffffff);
    refRendererCorgi.current.setScissorTest(false);
    refRendererCorgi.current.clear();
    refRenderer.current.setSize(
      canvasCorgi.clientWidth,
      canvasCorgi.clientHeight,
      false
    );

    // refRenderer.current.setClearColor(0xe0e0e0);
    refRendererCorgi.current.setScissorTest(true);
    let scrollY = window.scrollY;
    let currentSection = 0;

    updateSize();

    function updateSize() {
      /**
       *
       *
       * Renderer Modal
       *
       *
       */

      // if (!canvas3) return;
      //  const width4 = canvas3.clientWidth;
      // const height4 = canvas3.clientHeight;
      //  const elem4 = refSceneModal1.current.userData.element;

      // scene.userData.camera.aspect = elem.width / elem.height;
      // scene.userData.camera.updateProjectionMatrix();
      // console.log("canvas .canvas es, ", canvas.canvas);
      // refRenderer.current.setSize(width, height, false);

      // canvas.position = "absolute";
      // if (canvas3.width !== width4 || canvas3.height !== height4) {
      // refRenderer.current.setSize(
      //   window.innerWidth,
      //   window.innerHeight,
      //   false
      // );
      // refRenderer2.current.setSize(width4, height4, false);
      // scene.userData.camera.aspect = canvas.clientWidth / canvas.clientHeight;
      // }

      /**
       *
       *
       *
       * Renderer comun
       *
       *
       */
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const elem = scene.userData.element;

      // scene.userData.camera.aspect = elem.width / elem.height;
      // scene.userData.camera.updateProjectionMatrix();
      // console.log("canvas .canvas es, ", canvas.canvas);
      // refRenderer.current.setSize(width, height, false);

      // canvas.position = "absolute";
      if (canvas.width !== width || canvas.height !== height) {
        // refRenderer.current.setSize(
        //   window.innerWidth,
        //   window.innerHeight,
        //   false
        // );
        refRenderer.current.setSize(width, height, false);
        // scene.userData.camera.aspect = canvas.clientWidth / canvas.clientHeight;
      }
      const width2 = canvasCorgi.clientWidth;
      const height2 = canvasCorgi.clientHeight;

      // scene.userData.camera.aspect = elem.width / elem.height;
      // scene.userData.camera.updateProjectionMatrix();
      // console.log("canvas .canvas es, ", canvas.canvas);
      if (canvasCorgi.width !== width || canvasCorgi.height !== height) {
        refRendererCorgi.current.setSize(width2, height2, false);
        // scene.userData.camera.aspect = canvas.clientWidth / canvas.clientHeight;
      }
    }
    const canvas2 = document.getElementById("canvas2");
    // function updateSize2() {
    //   if (!canvas2) return;
    //   const width = canvas2.clientWidth;
    //   const height = canvas2.clientHeight;
    //   const elem = scene.userData.element;

    //   // scene.userData.camera.aspect = elem.width / elem.height;
    //   // scene.userData.camera.updateProjectionMatrix();
    //   // console.log("canvas .canvas es, ", canvas.canvas);
    //   refRenderer2.current.setSize(
    //     window.innerWidth,
    //     window.innerHeight,
    //     false
    //   );
    //   if (canvas2.width !== width || canvas2.height !== height) {
    //     // scene.userData.camera.aspect = canvas.clientWidth / canvas.clientHeight;
    //   }
    // }
    window.addEventListener("scroll", () => {
      scrollY = window.scrollY;
      const newSection = Math.round(scrollY / sizes.height);

      if (newSection != currentSection) {
        currentSection = newSection;

        // gsap.to(sectionMeshes[currentSection].rotation, {
        //   duration: 1.5,
        //   ease: "power2.inOut",
        //   x: "+=6",
        //   y: "+=3",
        //   z: "+=1.5",
        // });
      }
    });
    /**
     * Animate
     */
    const clock = new THREE.Clock();
    let previousTime = 0;
    let time = Date.now();
    let contador = 0;
    let contador2 = 0;
    // gsap.to(mesh.position, { duration: 1, delay: 1, x: 2 });
    // object1.rotation.y = 0;
    const funcionCambiar2 = () => {
      gsap.to(refModel21.current.rotation, {
        y: 1,
        duration: 4,
        onComplete: funcionCambiar,
      });
    };
    const funcionCambiar = () => {
      gsap.to(refModel21.current.rotation, {
        y: -1,
        duration: 4,
        onComplete: funcionCambiar2,
      });
    };
    gsap.to(refModel21.current.rotation, {
      y: 1,
      duration: 4,
      onComplete: funcionCambiar,
    });
    const funcionCambiarSegundo2 = () => {
      gsap.to(refModel22.current.rotation, {
        y: 1,
        duration: 4,
        onComplete: funcionCambiarSegundo,
      });
    };
    const funcionCambiarSegundo = () => {
      gsap.to(refModel22.current.rotation, {
        y: -1,
        duration: 4,
        onComplete: funcionCambiarSegundo2,
      });
    };
    gsap.to(refModel22.current.rotation, {
      y: 1,
      duration: 4,
      onComplete: funcionCambiarSegundo,
    });
    const funcionCambiarTercero2 = () => {
      gsap.to(refModel23.current.rotation, {
        y: 1,
        duration: 4,
        onComplete: funcionCambiarTercero,
      });
    };
    const funcionCambiarTercero = () => {
      gsap.to(refModel23.current.rotation, {
        y: -1,
        duration: 4,
        onComplete: funcionCambiarTercero2,
      });
    };
    gsap.to(refModel23.current.rotation, {
      y: 1,
      duration: 4,
      onComplete: funcionCambiarTercero,
    });

    //////Corgi
    // gsap.to(refPersonaje.current, {
    //   duration: 4,
    //   x: window.innerWidth - 300,
    //   // onComplete: funcionCambiarTercero,
    // });
    // gsap.to(refPersonaje.current, {
    //   xPercent: -50,
    //   left: "50%",
    //   yPercent: -50,
    //   top: "50%",
    //   position: "absolute",
    //   duration: 20,
    // });
    // const funcionCorgiAnimated2 = () => {
    //   gsap.to(refPersonaje.current, {
    //     // xPercent: -50,
    //     // left: "50%",
    //     // yPercent: -50,
    //     top: "20%",
    //     position: "absolute",
    //     duration: 3,
    //     onStart: () => {
    //       // document.getElementById("div-scene-corgi").style.background = "yellow";
    //       console.log("empezo!!");

    //       action.play();
    //     },
    //   });
    // };
    //Funciona la funcion de corgi
    // gsap.to(refPersonaje.current, {
    //   // xPercent: -50,
    //   // left: "0%",
    //   left: "-50px",
    //   // yPercent: -50,
    //   top: "-130px",
    //   // top: "0%",
    //   position: "absolute",
    //   duration: 2,
    //   // onComplete: funcionCorgiAnimated2,
    // });

    // setTimeout(() => {
    //   funcionDePie();
    // }, 2000);

    // const funcionDePie = () => {
    //   bailar = false;
    //   girarIzquierda = false;
    //   caminar = false;
    //   dePie = true;
    //   setTimeout(() => {
    //     funcionBailar();
    //   }, 2000);
    // };
    // const funcionBailar = () => {
    //   girarIzquierda = false;
    //   dePie = false;
    //   caminar = false;
    //   bailar = true;
    //   setTimeout(() => {
    //     funcionDePie("siempre");
    //   }, 3000);
    // };

    // const funcionCaminar = () => {
    //   caminar = false;
    //   girarIzquierda = false;
    //   dePie = false;
    //   bailar = true;
    //   setTimeout(() => {
    //     // funcionBailar();
    //   }, 2000);
    // };
    // const funcionIzquierda = () => {
    //   caminar = false;
    //   bailar = false;
    //   girarIzquierda = true;
    //   dePie = false;
    //   setTimeout(() => {
    //     funcionCaminar();
    //   }, 2000);
    // };
    // funcionCaminar();

    // const funcionDePie = (valor) => {
    //   caminar = false;
    //   girarIzquierda = false;
    //   bailar = false;
    //   dePie = true;
    //   if (valor === "siempre") return;
    //   setTimeout(() => {
    //     funcionBailar();
    //   }, 2000);
    // };
    // funcionDePie("rato");

    let caminar = false;
    let bailar = false;
    let girarIzquierda = false;
    let dePie1 = false;
    let dePie2 = false;
    // const funcionActivarBailar2 = () => {
    //   setTimeout(() => {
    //     idleDePie2.stop();
    //     idleBailar.play();
    //     estadoVolverBailar = false;
    //     dePie2 = false;
    //     bailar = true;
    //     // idleBailar.crossFadeFrom(idleDePie2, 1, true);
    //   }, 1500);
    // };
    // const funcionActivarBailar1 = () => {
    //   setTimeout(() => {
    //     idleBailar.play().reset();
    //     idleBailar.fadeIn(1);
    //     // idleBailar.setLoop(THREE.LoopOnce, 20);

    //     idleDePie1.stop();
    //     estadoVolverBailar = false;
    //     dePie1 = false;
    //     bailar = true;

    //   }, 1500);
    // };
    dePie1 = true;
    bailar = false;
    let estadoDePie = false;
    // idleDePie1.play();

    //Correcto play
    refPrimerAnimacion.current = idleDePie1;
    // refPrimerAnimacion.current.play();
    // idleDePie1.play();
    if (window.innerWidth < 768) {
      refCorgi.current.scale.set(0.35, 0.35, 0.35);
      refCorgi.current.position.y = 0;
    } else {
      refCorgi.current.scale.set(0.4, 0.4, 0.4);
    }
    // refCorgi.current.scale.set(0.06, 0.06, 0.06);
    // console.log("Matrix1 es: ", refCorgi.current.matrix);
    // refCorgi.current.rotation.x = Math.PI * 1.5;
    // refCorgi.current.rotation.z = Math.PI * 0.5;
    // refCorgi.current.rotation.z = Math.PI * 0.5;
    // refCorgi.current.children[0].rotation.x = Math.PI * 0.5;

    //Funcionaban
    // refCorgi.current.rotation.x = Math.PI * 0;
    // refCorgi.current.rotation.y = Math.PI * 0;
    // refCorgi.current.traverse(function (object) {
    //   if (object.isMesh) object.castShadow = true;
    // });
    sceneCorgi.add(refCorgi.current);
    // const skeleton = new THREE.SkeletonHelper(refCorgi.current);
    // skeleton.visible = true;
    // sceneCorgi.add(skeleton);
    // refCorgi.current.rotatçion.z = Math.PI * 0;
    // idleGirarIzquierda90.play();
    // idleGirarIzquierda90.fadeIn(0);
    // refCorgi.current.rotation.z = Math.PI * 0.5;
    // idleCaminar.play().reset();
    // idleCaminar.fadeIn(0);
    // idleClonePie2.play().reset();
    // idleClonePie2.setLoop(THREE.LoopRepeat, 200);
    // idleCloneGirarDerecha90.play();
    // idleCloneGirarDerecha90.setLoop(THREE.LoopRepeat, 1);
    // idleCloneGirarDerecha90.fadeIn(0);
    // idleCloneBailar1.play().reset();
    // idleCloneBailar1.fadeIn(0);

    //Activar esta siguiente propiedad
    refPersonaje.current.style.clipPath = "circle(0px)";

    // document.querySelector(".list-item-corgi").style.clipPath = "circle(0px)";
    // document.querySelector(".list-item-corgi").style.left = "0%";
    // refCorgi.current.position.x = -0.5;
    //Siguiente funcion activar
    // console.log("animacion , ", refPrimerAnimacion.current);
    // console.log("ref corgi es, ", refCorgi.current);
    // refPrimerAnimacion.current.play();
    // refPrimerAnimacion.current.clampWhenFinished = true;
    // refCorgi.current.rotation.x = Math.PI * 1.5;
    // refPrimerAnimacion.current.play();
    // refPrimerAnimacion.current.clampWhenFinished = true;
    // refCorgi.current.rotation.x = Math.PI * 1.5;
    // refPrimerAnimacion.current.play();
    // refPrimerAnimacion.current.setLoop(THREE.LoopRepeat, 30);
    // refPrimerAnimacion.current.clampWhenFinished = true;
    // refPrimerAnimacion.current.syncWith(idleBailar);
    // refCorgi.current.rotation.x = Math.PI * 1.5;

    // refPrimerAnimacion.current.paused = true;
    // idleBailar.stop();
    // idleBailar.syncWith(refPrimerAnimacion.current);
    // idleBailar.timeScale = 1;
    // idleBailar.time = 1;
    // idleBailar.weight = 0;
    // idleBailar.play().reset();
    // idleBailar.clampWhenFinished = true;
    // idleBailar.fadeIn(2);
    // idleBailar.crossFadeFrom(refPrimerAnimacion.current, 0.5, true).play();
    // setTimeout(() => {
    // }, 100);
    // console.log("refCorgi.current es, ", refCorgi.current);
    // refCorgi.current.quaternion.w = 0;
    // console.log("refCorgi.current es, ", refCorgi.current);

    // refCorgi.current.rotation.x = Math.PI * 0;
    ///////////////
    /////////////
    ///////////////
    //////////////

    /**
     *
     *
     * El siguiente codigo funciona bien
     *
     *
     */
    // console.log("idle bailar es, ", idleBailar);
    // idleBailar.play().reset();
    // idleBailar.fadeIn(2);
    // idleBailar.clampWhenFinished = true;
    // refCorgi.current.rotation.y = Math.PI * 0.5;
    /////////
    //////////
    ///////////
    //////////////

    // refCorgi.current.rotation.y = Math.PI * 0.5;
    // idleBailar.play().reset();
    // idleBailar.fadeIn(2);
    // idleBailar.clampWhenFinished = true;
    // idleCaminar.play().reset();
    // idleCaminar.fadeIn(1);
    //Correcta animacion
    // console.log("refPrimerAnimacion.current es, ", refPrimerAnimacion.current);
    const funcionPersonajeDesktop = () => {
      refPrimerAnimacion.current.play().reset();
      refPrimerAnimacion.current.clampWhenFinished = true;
      refPrimerAnimacion.current.fadeIn(1);
      refPrimerAnimacion.current.setLoop(THREE.LoopRepeat, 2);
      refCorgi.current.scale.set(0.4, 0.4, 0.4);
      refCorgi.current.position.y = -0.18;
      // refCorgi.current.position.y = 0;
      refGsap11.current = gsap.to(refPersonaje.current, {
        duration: 0,
        startAt: {
          // left: "-3px",
          // left: temporalNumero,
          //Linea siguiente correcta
          // left: "0%",
          top: "0px",
          position: "fixed",
          // width: "500px",
          // height: "500px",
        },
        transform: "rotate(0deg)",
        xPercent: 0,
        left: "0%",
        force3D: true,
        // x: (37 * window.innerWidth) / 100,
        // x: "50%",
        width: 500,
        height: 500,
        position: "fixed",
        // left: 400,
        // top: "0px",
        ease: "none",
        overwrite: true,
        onComplete: () => {
          // gsap.to(refCorgi.current.rotation, {
          //   x: Math.PI * 2,
          //   delay: 0,
          //   onComplete: () => {
          //     setTimeout(() => {
          //       idleBailar.zeroSlopeAtStart = false;
          //       idleBailar.play().reset();
          //       idleBailar.clampWhenFinished = true;
          //       idleBailar.fadeIn(2);
          //     }, 1000);
          //   },
          // });
        },
      });

      // const tickPrueba = () => {
      //   if (idleBailar.isRunning()) {
      //     // refCorgi.current.rotation.x = Math.PI * 1.5;
      //     console.log("se ejecuta funcion bailar");
      //   }
      //   window.requestAnimationFrame(tickPrueba);
      // };
      // tickPrueba();
      stand1.addEventListener("finished", function (e) {
        //caminar
        // console.log("termino stand1");
        refPersonaje.current.style.clipPath = "circle(0px)";
        // document.querySelector(".list-item-corgi").style.clipPath = "circle(0px)";
        // console.log("termino stand!!, ", e);
        idleBailar.play().reset();
        idleBailar.setLoop(THREE.LoopRepeat, 1);
        // idleBailar.syncWith(refPrimerAnimacion.current);
        // idleBailar
        //   .crossFadeFrom(refPrimerAnimacion.current, 0.5, true)
        //   .play()
        //   .reset();
        idleBailar.fadeIn(2);
        idleBailar.clampWhenFinished = true;
        // refPrimerAnimacion.current.stop();

        // refCorgi.current.rotation.x = Math.PI * 0;
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // idleBailar.crossFadeTo(idleDePie1, 2, true);
        // console.log("termino stand 1");
        // try {
        //   console.log("idleClonePie6 es: ", idleClonePie6);
        //   idleClonePie6.play().reset();
        //   idleClonePie6.clampWhenFinished = true;
        //   idleClonePie6.fadeIn(2);
        //   idleClonePie6.setLoop(THREE.LoopRepeat, 100);
        //   // idleClonePie6.play();
        //   // idleClonePie6.setLoop(THREE.LoopRepeat, 20);
        // } catch (error) {
        //   console.log("error es , ", error);
        // }
        // refPrimerAnimacion.current.enabled = false;
        // refPrimerAnimacion.current.stop();
        // refPrimerAnimacion.current.fadeOut(2);
        // idleBailar.enabled = false;
        // refCorgi.current.rotation.x = Math.PI * 0;

        // idleBailar.play().reset();
        // idleBailar.clampWhenFinished = true;
        // idleBailar.fadeIn(2);
        // idleBailar.setLoop(THREE.LoopRepeat, 1);
        let animacionCaminar1;
        /**
         *
         *
         * Fin del codigo
         *
         *
         */
        // idleBailar.stop();
        // mixer.uncacheRoot(idleBailar);
        // mixer.uncacheAction(idleBailar);

        // idleBailar.clampWhenFinished = true;
        // // refCorgi.current.rotation.x = Math.PI * 1.5;
        // idleBailar.play().reset();
        // // refCorgi.current.rotation.x = Math.PI * 1.5;
        // idleBailar.clampWhenFinished = true;
        // // idleBailar.fadeIn(2);
        // idleBailar.fadeIn(2);
        // // idleBailar.fadeIn(1);
        // idleBailar.setLoop(THREE.LoopRepeat, 1);
        // idleBailar.clampWhenFinished = true;

        // stand1.stopAllAction();
        // idleDePie1.stop();
        // refPrimerAnimacion.current.clampWhenFinished = true;
        // refPrimerAnimacion.current.stop();
        // console.log("Matrix2 es: ", refCorgi.current.matrix);
      });
      standClone6.addEventListener("finished", function (e) {
        // idleBailar.stop();
        // mixer.uncacheRoot(idleBailar);
        // mixer.uncacheAction(idleBailar);
        console.log("termino stand 2");

        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // idleBailar.clampWhenFinished = true;
        idleBailar.play().reset();
        idleBailar.clampWhenFinished = true;
        idleBailar.fadeIn(2);
        idleBailar.setLoop(THREE.LoopRepeat, 1);
        // idleBailar.fadeIn(2);
        // idleBailar.fadeIn(1);
      });
      let primero = false;
      mixer.addEventListener("finished", function (e) {
        // refPrimerAnimacion.current.stop();
        // return;
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // if (!primero) {
        //   refCorgi.current.rotation.x = Math.PI * 1.5;
        //   primero = true;
        // } else {
        //   // refCorgi.current.rotation.x = Math.PI * 0.75;
        // }
        //caminar
        // console.log("termino bailar!!, ", e);

        // refPrimerAnimacion.current.fadeOut(1);
        // idleBailar.play().reset();
        // console.log("idClonePie1 es, ", idleClonePie1);
        // console.log("ref corgi es terminio de bailar, ", refCorgi.current);
        // idleBailar.fadeOut(1);
        idleClonePie1.play().reset();
        idleClonePie1.clampWhenFinished = true;
        idleClonePie1.fadeIn(2);
        idleClonePie1.setLoop(THREE.LoopRepeat, 1000);

        refGsap1.current = gsap.to(refCorgi.current.rotation, {
          y: Math.PI * 0.5,
          duration: 1.5,
          overwrite: true,
          onComplete: () => {
            setTimeout(() => {
              // refCorgi.current.rotation.x = Math.PI * 0;
              // refCorgi.current.rotation.x = Math.PI * 1.5;
              // idleCaminar.play().reset();
              // idleCaminar.fadeIn(1);
              // idleCaminar.setLoop(THREE.LoopRepeat, 10000);
              // idleCaminar.clampWhenFinished = true;
              // refCorgi.current.rotation.x = Math.PI * 1.5;
              refCorgi.current.rotation.y = Math.PI * 0.5;

              idleCaminar.play().reset();
              idleCaminar.fadeIn(1);
              idleClonePie1.stop();
              idleBailar.stop();
              funcionCaminar1();
            }, 100);
          },
        });
        // idleBailar.stop();
        // idleBailar.stop();
        // idleDePie1.play();
        // idleDePie1.setLoop(THREE.LoopRepeat, 50);
        // idleDePie1.fadeIn(2);
        // idleBailar.stop();
        // dePie1 = true;
        // bailar = false;
      });
      standClone1.addEventListener("finished", function (e) {
        //caminar
        // console.log("termino stand2!!, ", e);
        // refCorgi.current.rotation.z = Math.PI * 0;
        // idleGirarIzquierda90.play().reset();
        // idleGirarIzquierda90.fadeIn(1);
        // idleClonePie1.play().reset();
        // idleClonePie1.setLoop(THREE.LoopRepeat, 1);
        // idleClonePie1.fadeIn(1);
        // stand1.stopAllAction();
      });

      standClone2.addEventListener("finished", function (e) {
        //caminar
        // console.log("termino stand2!!, ", e);
        // idleCaminar.duration = 5;
      });
      const funcionCaminar1 = () => {
        // refCorgi.current.rotation.x = Math.PI * 0;
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        idleCaminar.play().reset();
        idleCaminar.clampWhenFinished = true;
        // idleCaminar.duration = 5;
        // idleCaminar.setDuration(1);
        // idleCaminar.clampWhenFinished = true;
        // idleCaminar.setTime(3);
        // idleCaminar.setLoop(THREE.LoopRepeat, 3);
        // idleCaminar.setLoop()
        idleCaminar.fadeIn(1);
        refPersonaje.current.style.width = "500px";
        refPersonaje.current.style.height = "500px";
        refPersonaje.current.style.top = "0px";
        // refPersonaje.current.style.left = "4%";
        refPersonaje.current.style.clipPath = "circle(0px)";
        // document.querySelector(".list-item-corgi").style.clipPath = "circle(0px)";
        // const temporalNumero = (window.innerWidth * 10) / 100;
        // refPersonaje.current.style.left = temporalNumero;
        // console.log("left es, ", refPersonaje.current.style.left);

        // refPersonaje.current
        setTimeout(() => {
          refGsap2.current = gsap.to(refPersonaje.current, {
            duration: 5,

            startAt: {
              // left: "-3px",
              // left: temporalNumero,
              left: "0%",
              top: "0px",
              position: "fixed",
              width: "500px",
              height: "500px",
            },
            overwrite: true,
            force3D: true,
            transform: "rotate(0deg)",
            xPercent: -50,
            left: "50%",
            // x: (37 * window.innerWidth) / 100,
            // x: "50%",
            width: 500,
            height: 500,
            position: "fixed",
            // left: 400,
            // top: "0px",
            ease: "none",

            onComplete: () => {
              idleCaminar.fadeOut(0.1);
              // funcionDespuesDeWalking1();
              // console.log("termino complete");
              refGsap3.current = gsap.to(refCorgi.current.rotation, {
                y: Math.PI * 0,
                duration: 2,
                overwrite: true,
                onComplete: () => {
                  // refCorgi.current.rotation.x = Math.PI * 0;
                  // refCorgi.current.rotation.x = Math.PI * 1.5;
                  idleCloneBailar1.play().reset();
                  idleCloneBailar1.setLoop(THREE.LoopRepeat, 1);
                  idleCloneBailar1.clampWhenFinished = true;
                  idleCloneBailar1.fadeIn(2);
                },
              });
              // idleClonePie3.play().reset();
              // idleClonePie3.setLoop(THREE.LoopRepeat, 20);
              // idleClonePie3.fadeIn(1);
              // idleCloneGirarDerecha90.play().reset();
              // idleCloneGirarDerecha90.setLoop(THREE.LoopRepeat, 1);
              // idleCloneGirarDerecha90.fadeIn(2);
              // idleCaminar.stop();
            },
            // onStart: () => {
            //   setTimeout(() => {
            //     // idleCaminar.fadeOut(0.89);
            //     // idleCaminar.stop();
            //     // idleCaminar.setLoop(THREE.LoopRepeat, 1);
            //     // idleCaminar.enabled = false;
            //   }, 4500);
            // },
          });
        }, 85);
      };
      // walking.addEventListener("finished", function (e) {
      //   //caminar
      //   console.log("termino de caminar!!, ", e);
      //   idleCloneGirarDerecha90.play().reset();
      //   idleCloneGirarDerecha90.setLoop(THREE.LoopRepeat, 1);
      // });
      /**
       *
       *
       *
       * Segunda Etapa
       *
       *
       *
       *
       *
       */
      bailarClone1.addEventListener("finished", function (e) {
        //caminar
        // console.log("termino de bailar2!!, ", e);
        // idleCloneBailar1.stop();
        // refCorgi.current.rotation.x = Math.PI * 0;
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // idleClonePie4.play().reset();
        // idleClonePie4.clampWhenFinished = true;
        // idleClonePie4.fadeIn(5);
        // idleClonePie4.setLoop(THREE.LoopRepeat, 10000);
        idleClonePie1.play().reset();
        idleClonePie1.clampWhenFinished = true;
        idleClonePie1.fadeIn(2);
        idleClonePie1.setLoop(THREE.LoopRepeat, 10000);
        /////////
        refGsap4.current = gsap.to(refCorgi.current.rotation, {
          y: Math.PI * 0.5,
          duration: 1.5,
          overwrite: true,
          onComplete: () => {
            // idleClonePie4.play().reset();
            // idleClonePie4.fadeIn(0);
            // idleClonePie4.setLoop(THREE.LoopRepeat, 1);
            setTimeout(() => {
              // idleCloneCaminar1.play().reset();
              // idleCloneCaminar1.fadeIn(1);
              // refCorgi.current.rotation.z = Math.PI * 0.5;
              // idleCaminar.play().reset();
              // idleCaminar.fadeIn(1);
              idleCaminar.play().reset();
              idleCaminar.clampWhenFinished = true;
              idleCaminar.fadeIn(2);
              idleClonePie1.stop();
              funcionCaminar2();
            }, 100);
            // idleClonePie4.play().reset();
            // idleClonePie4.fadeIn(2);
            // funcionCaminar2();
          },
          // onStart: () => {
          //   idleClonePie4.play().reset();
          //   idleClonePie4.fadeIn(0.5);
          //   idleClonePie4.setLoop(THREE.LoopRepeat, 100);
          // },
        });
      });

      const funcionCaminar2 = () => {
        refPersonaje.current.style.width = "500px";
        refPersonaje.current.style.height = "500px";
        // refPersonaje.current.style.top = "0px";
        // refPersonaje.current.style.left = "50%";
        refPersonaje.current.style.clipPath = "circle(0px)";
        // document.querySelector(".list-item-corgi").style.clipPath = "circle(0px)";
        // refPersonaje.current
        // const temporalLeft = refPersonaje.current.style.left;

        setTimeout(() => {
          refGsap5.current = gsap.to(refPersonaje.current, {
            duration: 5,
            startAt: {
              left: `50%`,
              // top: "0px",
              position: "fixed",
              width: "500px",
              height: "500px",
            },
            overwrite: true,
            force3D: true,
            transform: "rotate(0deg)",
            xPercent: -10,
            // left: "70%",
            left: window.innerWidth - 500,
            // x: window.innerWidth / 2 - 350,
            // right: "0%",
            // right: "0%",
            // x: (37 * window.innerWidth) / 100,
            // x: "50%",
            width: 500,
            height: 500,
            position: "fixed",
            // left: 400,
            // top: "0px",
            ease: "none",

            onComplete: () => {
              // funcionDespuesDeWalking1();
              idleCaminar.fadeOut(0.1);
              // console.log("termino complete");
              refGsap6.current = gsap.to(refCorgi.current.rotation, {
                y: Math.PI * 0,
                duration: 1.5,
                overwrite: true,
                onComplete: () => {
                  // idleCloneBailar1.play().reset();
                  // idleCloneBailar1.fadeIn(2);
                  // refCorgi.current.rotation.x = Math.PI * 0;
                  // refCorgi.current.rotation.x = Math.PI * 1.5;
                  idleCloneBailar2.play().reset();
                  idleCloneBailar2.clampWhenFinished = true;
                  idleCloneBailar2.fadeIn(2);
                },
              });
              // idleClonePie3.play().reset();
              // idleClonePie3.setLoop(THREE.LoopRepeat, 20);
              // idleClonePie3.fadeIn(1);
              // idleCloneGirarDerecha90.play().reset();
              // idleCloneGirarDerecha90.setLoop(THREE.LoopRepeat, 1);
              // idleCloneGirarDerecha90.fadeIn(2);
              // idleCaminar.stop();
            },
          });
        }, 245);
      };

      /**
       *
       *
       *
       * Tercera etapa
       *
       *
       *
       */
      bailarClone2.addEventListener("finished", function (e) {
        //caminar
        // console.log("termino bailar!!, ", e);
        // dePie1 = true;
        // bailar = false;
        // idleBailar.play().reset();
        // console.log("idClonePie1 es, ", idleClonePie1);
        // refCorgi.current.rotation.x = Math.PI * 0;
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // idleClonePie5.play().reset();
        // idleClonePie5.clampWhenFinished = true;
        // idleClonePie5.fadeIn(2);
        // idleClonePie5.setLoop(THREE.LoopRepeat, 1000);
        // idleBailar.stop();
        // idleClonePie1.stop();
        // idleCloneBailar2.stop();
        idleCloneBailar2.fadeOut(1);
        idleCloneBailar2.paused = true;
        idleClonePie1.play().reset();
        idleClonePie1.clampWhenFinished = true;
        idleClonePie1.fadeIn(2);
        idleClonePie1.setLoop(THREE.LoopRepeat, 10000);

        // idleCaminar.stop();

        // idleCaminar.stop();
        // idleCloneBailar1.stop();
        // idleClonePie1.stop();
        refGsap7.current = gsap.to(refCorgi.current.rotation, {
          y: Math.PI * -0.5,
          duration: 1.5,
          overwrite: true,
          onStart: () => {
            // idleCaminar.stop();

            // idleCaminar.stop();
            idleCloneBailar2.stop();
            // idleClonePie1.stop();
          },
          onComplete: () => {
            setTimeout(() => {
              idleClonePie1.stop();
              // refCorgi.current.rotation.x = Math.PI * 0;
              // refCorgi.current.rotation.x = Math.PI * 1.5;
              idleCaminar.play().reset();
              idleCaminar.clampWhenFinished = true;

              idleCaminar.fadeIn(1);
              idleCaminar.clampWhenFinished = true;
              idleCloneBailar2.stop();
              // idleCaminar.setLoop(THREE.LoopRepeat, 10000);
              // idleCaminar.clampWhenFinished = true;
              funcionCaminar3();
            }, 100);
          },
        });
      });
      const funcionCaminar3 = () => {
        // refPersonaje.current.style.width = "500px";
        // refPersonaje.current.style.height = "500px";
        // refPersonaje.current.style.top = "0px";
        // refPersonaje.current.style.left = "70%";
        refPersonaje.current.style.clipPath = "circle(0px)";
        // document.querySelector(".list-item-corgi").style.clipPath = "circle(0px)";
        // refPersonaje.current

        setTimeout(() => {
          refGsap8.current = gsap.to(refPersonaje.current, {
            duration: 10,
            startAt: {
              // left: `100%`,
              // right: "3%",
              // x: window.innerWidth / 2 - 350,
              // left: window.innerWidth / 2 - 500,
              left: window.innerWidth - 500,
              top: "0px",
              position: "fixed",
              width: "500px",
              height: "500px",
            },
            overwrite: true,
            force3D: true,
            // transform: "rotate(0deg)",
            // xPercent: -100,
            // left: "10px",
            // left: temporalNumero,
            left: "0%",
            xPercent: 0,
            // x: 10,
            // right: "0%",
            // x: (37 * window.innerWidth) / 100,
            // x: "50%",
            width: 500,
            height: 500,
            position: "fixed",
            // left: 400,
            // top: "0px",
            ease: "none",

            onComplete: () => {
              // funcionDespuesDeWalking1();
              // idleBailar.clampWhenFinished = true;
              // idleCaminar.clampWhenFinished = true;

              idleCaminar.clampWhenFinished = true;
              // idleCaminar.paused = true;
              idleCaminar.fadeOut(0.1);

              // console.log("termino complete");
              refGsap9.current = gsap.to(refCorgi.current.rotation, {
                y: Math.PI * 0,
                duration: 1.5,
                overwrite: true,
                onComplete: () => {
                  // idleBailar.fadeIn(2);
                  // bailarClone3
                  // mixer =
                  // idleBailar = mixer.clipAction(anim33.animations[0]);
                  // idleBailar.setLoop(THREE.LoopRepeat, 1);
                  // idleBailar.fadeIn(2);
                  /**
                   *
                   *
                   * El siguiente codigo funciona bien
                   *
                   */
                  // idleBailar.play().reset();
                  // idleBailar.fadeIn(2);
                  // idleBailar.clampWhenFinished = true;

                  /**
                   *
                   *
                   * Fin del codigo
                   *
                   */
                  // refCorgi.current.rotation.x = Math.PI * 0;
                  ///////////////////////////////
                  idleBailar.stop();
                  idleCaminar.stop();
                  idleCloneBailar2.stop();
                  idleCaminar.stop();
                  idleCloneBailar1.stop();
                  idleClonePie1.stop();
                  //////////////////////////////
                  idleBailar.stopWarping();
                  idleCloneBailar2.stopWarping();
                  idleCloneBailar1.stopWarping();
                  ////////////////////////////
                  mixer.stopAllAction();
                  bailarClone1.stopAllAction();
                  bailarClone2.stopAllAction();
                  // idleBailar.stop();
                  // idleBailar.play().reset();
                  // idleBailar.fadeIn(2);

                  refPrimerAnimacion.current.play().reset();
                  refPrimerAnimacion.current.setLoop(THREE.LoopRepeat, 1);
                  refPrimerAnimacion.current.fadeIn(1);

                  // idleClonePie5.play().reset();
                  // idleClonePie5.setLoop(THREE.LoopRepeat, 10);
                  // idleClonePie5.fadeIn(1);

                  // refPrimerAnimacion.current.fadeOut(2);

                  // refPrimerAnimacion.current.clampWhenFinished = true;
                  // idleBailar.play().reset();
                  // idleBailar.fadeIn(2);
                  // refCorgi.current.rotation.x = Math.PI * 0;
                  // refCorgi.current.rotation.x = Math.PI * 1.5;
                  // idleDePie1.play().reset();
                  // idleBailar.clampWhenFinished = true;
                  // idleBailar.play().reset();
                  // idleBailar.fadeIn(2);
                  // idleBailar.clampWhenFinished = true;
                  // refPrimerAnimacion.current.clampWhenFinished = true;
                  // refPrimerAnimacion.current.play().reset();
                  // refPrimerAnimacion.current.fadeIn(1);
                  // refPrimerAnimacion.current.setLoop(THREE.LoopRepeat, 30);
                  // refPrimerAnimacion.current.clampWhenFinished = true;
                  // idleCloneBailar1.play().reset();
                  // idleCloneBailar1.fadeIn(2);
                  // idleCloneBailar2.play().reset();
                  // idleCloneBailar2.fadeIn(2);
                },
              });
              // idleClonePie3.play().reset();
              // idleClonePie3.setLoop(THREE.LoopRepeat, 20);
              // idleClonePie3.fadeIn(1);
              // idleCloneGirarDerecha90.play().reset();
              // idleCloneGirarDerecha90.setLoop(THREE.LoopRepeat, 1);
              // idleCloneGirarDerecha90.fadeIn(2);
              // idleCaminar.stop();
            },
          });
        }, 235);
      };
    };
    // refPersonaje.current.style.width = "500px";
    // refPersonaje.current.style.height = "500px";
    // gsap.to(refPersonaje.current, {
    //   duration: 4,
    //   x: (37 * window.innerWidth) / 100,
    //   // x: "50%",
    //   width: 500,
    //   height: 500,
    //   // left: 400,
    //   // onComplete: funcionCambiarTercero,
    // });
    /**
     *
     *
     *
     *
     *
     *
     *
     *
     */
    refPickHelper1.current = new PickHelper();
    refPickHelper1.current.click();
    refPickHelper2.current = new PickHelper();
    refPickHelper2.current.click();
    refPickHelper3.current = new PickHelper();
    refPickHelper3.current.click();

    ///////////
    refPickHelperSelectMatilda.current = new PickHelperSelect();
    refPickHelperSelectMatilda.current.click();
    refPickHelperSelectJoe.current = new PickHelperSelect();
    refPickHelperSelectJoe.current.click();
    // const pickCorgi = new PickHelper();
    // pickCorgi.click();
    // const funcionSacarModal = () => {
    //   pickHelper.setModal1(false);
    // };
    // refPickHelper1.current = pickHelper;
    // refPickHelper2.current = pickHelper2;
    // refPickHelper3.current = pickHelper3;
    // console.log("scenes es, ", scenes);
    let time2 = Date.now();
    // const controls = new OrbitControls(
    //   scenePerson1.userData.camera,
    //   document.querySelector(".prueba3")
    // );
    // controls.minDistance = 2;
    // controls.maxDistance = 5;
    // controls.enablePan = false;
    // controls.enableZoom = true;
    // scenePerson1.userData.controls = controls;
    // let time2 = Date.now();
    let estadoVolverBailar = false;
    let estadoEmpezarBailar = false;
    const velocidadAnimacion = 0.001;
    // const velocidadAnimacion = 0.002;
    // refPersonaje.current.style.display = "block";
    refCarousel1.current.style.display = "block";
    refCarousel2.current.style.display = "none";
    refCarousel3.current.style.display = "none";
    // if (window.innerWidth < 768) {
    //   refPersonaje.current.style.display = "none";
    // } else {
    //   refPersonaje.current.style.display = "block";
    // }
    // refCorgi.current.rotateY(Math.PI * 0);
    // refCorgi.current.rotateX(Math.PI * 1.5);
    const funcionesPersonajeMobile = () => {
      if (refGsap1.current) {
        refGsap1.current.pause();
      }
      if (refGsap2.current) {
        refGsap2.current.pause();
      }
      if (refGsap3.current) {
        refGsap3.current.pause();
      }
      if (refGsap4.current) {
        refGsap4.current.pause();
      }
      if (refGsap5.current) {
        refGsap5.current.pause();
      }
      if (refGsap6.current) {
        refGsap6.current.pause();
      }
      if (refGsap7.current) {
        refGsap7.current.pause();
      }
      if (refGsap8.current) {
        refGsap8.current.pause();
      }
      if (refGsap9.current) {
        refGsap9.current.pause();
      }
      if (refGsap10.current) {
        refGsap10.current.pause();
      }
      if (refGsap11.current) {
        refGsap11.current.pause();
      }
      if (refGsap12.current) {
        refGsap12.current.pause();
      }
      idleBailarMobile.stop();
      idleBailar.stop();
      idleCaminar.stop();
      idleCloneBailar2.stop();
      idleCaminar.stop();
      idleCloneBailar1.stop();
      idleClonePie1.stop();
      refPrimerAnimacion.current.stop();

      // refPersonaje.current.style.clipPath = "circle(100px)";
      // console.log("window inner width es , ", window.innerWidth);
      // refPersonaje.current.style.left = window.innerWidth / 2 + "px";

      gsap.to(refPersonaje.current, {
        duration: 0,
        startAt: {
          // left: "-3px",
          // left: temporalNumero,
          //Linea siguiente correcta
          // left: "0%",
          // left: -60,
          top: 0,
          // position: "fixed",
          // width: "500px",
          // height: "500px",
          // x: -500,
          // left: "0px",
          // xPercent: -50,
          x: 0,
        },
        transform: "rotate(0deg)",
        // xPercent: -50,
        // left: "0%",
        force3D: true,
        // x: (-30 * window.innerWidth) / 100,
        left: "-170px",
        // x: windowWidth -170,
        // x: -500,
        width: 500,
        height: 500,
        position: "fixed",
        // left: 400,
        // top: "0px",
        ease: "none",
        // top: -10,
        // ease: "power3.out",
        onComplete: () => {
          // console.log("se movio");
        },
      });
      // refGsap10.current.play();
      idleBailarMobile.stop();

      refPersonaje.current.style.display = "block";
      idleBailarMobile.play();
      idleBailarMobile.fadeIn(2);
      idleBailarMobile.setLoop(THREE.LoopRepeat);
      refCorgi.current.scale.set(0.35, 0.35, 0.35);
      refCorgi.current.position.y = 0;
    };
    if (window.innerWidth < 768) {
      // console.log("entra en mobile");
      // funcionesGsap();
      funcionesPersonajeMobile();
    } else {
      // console.log("entra en desktop");
      refPersonaje.current.style.display = "block";
      funcionPersonajeDesktop();
    }
    setPrimerAnimacion(true);
    const tick = () => {
      /**
       *
       * Texto 3d
       */
      if (uniforms) {
        const time = Date.now() * 0.001;
        shaderMaterial.uniforms.amplitude.value = 1.0 + Math.sin(time * 0.5);
        shaderMaterial.uniforms.amplitude.value = 1.0 + Math.sin(time * 0.5);
        shaderMaterial.uniformsNeedUpdate = true;
      }
      // const rayOrigin = new THREE.Vector3(-3, 0, 0);
      // const rayDirection = new THREE.Vector3(0, 0, 0);
      // rayDirection.normalize();
      // raycaster.setFromCamera(mouse, camera);

      // const objectsToTest = [object1, object2, object3];
      // const intersects = raycaster.intersectObjects(objectsToTest);

      // raycaster.setFromCamera(mouse, camera);
      // if (intersects.length) {
      //   if (!refCurrentIntersect.current) {
      //     // console.log("mouse enter");
      //     // document.body.style.cursor = "pointer";
      //   }
      //   refCurrentIntersect.current = intersects[0];
      // } else {
      //   if (refCurrentIntersect.current) {
      //     // console.log("mouse leave");
      //   }

      //   refCurrentIntersect.current = null;
      // }
      const currentTime = Date.now();
      const deltaTime = currentTime - time2;
      time2 = currentTime;
      if (smart) {
        smart.rotation.y += deltaTime * 0.0002;
      }
      // if (mixer) {
      //   mixer.update(deltaTime * 0.001);
      // }
      // if (caminar) {
      //   walking.update(deltaTime * 0.001);
      // } else if (bailar) {
      //   mixer.update(deltaTime * 0.001);
      // } else if (girarIzquierda) {
      //   turnLeft.update(deltaTime * 0.001);
      // } else if (dePie) {
      //   stand.update(deltaTime * 0.001);
      // } else {
      //   stand.update(deltaTime * 0.001);
      // }
      // if (walking) {
      //   walking.update(deltaTime * 0.001);
      // }
      // if (dePie) {
      //   stand.update(deltaTime * 0.001);
      // }

      // console.log("running stand", idleDePie2.isRunning());
      // if (stand1) {
      //   stand1.update(deltaTime * 0.001);
      // }
      // if (mixer) {
      //   mixer.update(deltaTime * 0.001);
      // }

      if (refCorgi.current) {
        // refCorgi.current.updateMatrix();
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // refCorgi.current.rotation.y = Math.PI * 0;
        // console.log("funciona rotation");
        // refCorgi.current.children[0].rotation.x = Math.PI * 0.5;
        // refCorgi.current.rotation.x = Math.PI * 1.5;
        // refCorgi.current.rotation.y = Math.PI * 0;
      }
      // console.log("variableCompleto", variableCompleto);
      // console.log(" document.visibilityState", document.visibilityState);
      // if (document.hasFocus() || document.visibilityState === "visible") {
      // if (document.hasFocus() || !document.hidden) {
      // if (document.visibilityState === "visible") {
      if (stand1) {
        stand1.update(deltaTime * velocidadAnimacion);
      }

      if (mixer) {
        mixer.update(deltaTime * velocidadAnimacion);
      }

      if (standClone1) {
        standClone1.update(deltaTime * velocidadAnimacion);
      }
      if (turnLeft) {
        turnLeft.update(deltaTime * velocidadAnimacion);
      }
      if (standClone2) {
        standClone2.update(deltaTime * velocidadAnimacion);
      }
      if (walking) {
        walking.update(deltaTime * velocidadAnimacion);
      }

      if (walkingClone1) {
        walkingClone1.update(deltaTime * velocidadAnimacion);
      }

      if (turnRight) {
        turnRight.update(deltaTime * velocidadAnimacion);
      }
      if (bailarClone1) {
        bailarClone1.update(deltaTime * velocidadAnimacion);
      }
      if (standClone3) {
        standClone3.update(deltaTime * velocidadAnimacion);
      }
      if (standClone4) {
        standClone4.update(deltaTime * velocidadAnimacion);
      }

      if (turnLeftClone2) {
        turnLeftClone2.update(deltaTime * velocidadAnimacion);
      }
      if (bailarClone2) {
        bailarClone2.update(deltaTime * velocidadAnimacion);
      }
      if (standClone5) {
        standClone5.update(deltaTime * velocidadAnimacion);
      }

      if (bailarCloneMobile) {
        bailarCloneMobile.update(deltaTime * velocidadAnimacion);
      }
      // }
      //////Lente smart

      // if (stand1 && dePie1) {
      //   console.log("entra en dePie 1");

      //   stand1.update(deltaTime * 0.001);
      //   // if (!estadoEmpezarBailar) {
      //   //   funcionActivarBailar1();
      //   //   estadoEmpezarBailar = true;
      //   // }
      // }
      // if (mixer && bailar) {
      //   console.log("entra en bailar");
      //   mixer.update(deltaTime * 0.001);
      // }
      // if (stand2 && dePie2) {
      //   console.log("entra en stand");
      //   stand2.update(deltaTime * 0.001);
      //   // if (!estadoVolverBailar) {
      //   //   funcionActivarBailar2();
      //   //   estadoVolverBailar = true;
      //   // }
      // }

      // if (!bailar && !dePie1) {
      //   idleDePie1.play().reset();
      //   if (stand1) {
      //     stand1.update(deltaTime * 0.001);
      //   }
      // }
      // if (walking) {
      //   // idle2.setLoop(THREE.LoopRepeat);
      //   walking.update(deltaTime * 0.001);
      // }

      updateSize();

      // if (window.innerWidth < 600) {
      //   canvas.style.transform = `translateY(${window.scrollY - 5000}px)`;
      // }

      canvas.style.transform = `translateY(${window.scrollY}px)`;
      // canvasCorgi.style.transform = `translateY(${window.scrollY}px)`;
      // canvasCorgi.style.height = window.innerHeight;
      // refPersonaje.current.style.top = 0;

      // canvas3.style.transform = `translateY(${window.scrollY}px)`;

      // refRenderer.current.setClearColor(0xe0e0e0);
      // refRenderer.current.setScissorTest(true);
      scenes.forEach(function (scene, index) {
        refElement.current = scene.userData.element;
        // get the element that is a place holder for where we want to
        // draw the scene
        const element = scene.userData.element;
        const camera = scene.userData.camera;

        // get its position relative to the page's viewport
        const rect = element.getBoundingClientRect();

        // check if it's offscreen. If so skip it
        if (
          rect.bottom < 0 ||
          rect.top > refRenderer.current.domElement.clientHeight ||
          rect.right < 0 ||
          rect.left > refRenderer.current.domElement.clientWidth
        ) {
          return; // it's off screen
        }

        // set the viewport
        const width = rect.right - rect.left;
        const height = rect.bottom - rect.top;
        const left = rect.left;
        const bottom =
          refRenderer.current.domElement.clientHeight - rect.bottom;

        refRenderer.current.setViewport(left, bottom, width, height);
        refRenderer.current.setScissor(left, bottom, width, height);

        //camera.aspect = width / height; // not changing in this example
        scene.userData.camera.aspect = rect.width / rect.height;
        scene.userData.camera.updateProjectionMatrix();

        // raycaster.setFromCamera(mouse, scene.userData.camera);
        // // get the list of objects the ray intersected
        // const intersectedObjects = raycaster.intersectObjects(scene.children);
        // if (intersectedObjects.length) {
        //   if (!refCurrentIntersect.current) {
        //     console.log("mouse enter");
        //     document.body.style.cursor = "pointer";
        //   }
        //   // console.log("intersect es, ", intersectedObjects[0]);
        //   refCurrentIntersect.current = intersectedObjects[0];
        // } else {
        //   if (refCurrentIntersect.current) {
        //     console.log("mouse leave");
        //     document.body.style.cursor = "default";
        //   }

        //   refCurrentIntersect.current = null;
        // }
        // let pickedObjectSavedColor = undefined;
        // let pickedObject = undefined;
        // if (pickedObject) {
        //   pickedObject.material.emissive.setHex(pickedObjectSavedColor);
        //   pickedObject = undefined;
        // }
        // if (intersectedObjects.length) {
        //   // pick the first object. It's the closest one
        //   pickedObject = intersectedObjects[0].object;
        //   pickedObjectSavedColor = pickedObject.material.emissive.getHex();

        //   pickedObject.material.emissive.setHex(0xff0000);
        // }
        if (scene.userData.nombre === "scene") {
          refPickHelper1.current.pick(mouse, scene, scene.userData.camera);
          // console.log("pick get modal es, ", pickHelper.getModal);
          // setModal1(refPickHelper1.current.getModal);

          // setModal(pickHelper.getModal);
          // pickHelper.setModal1(false);
        } else if (scene.userData.nombre === "scene2") {
          refPickHelper2.current.pick(mouse2, scene, scene.userData.camera);
          // setModal2(refPickHelper2.current.getModal);
          // setModal2(refPickHelper2.current.getModal);

          // setModal2(true);
        } else if (scene.userData.nombre === "scene3") {
          refPickHelper3.current.pick(mouse3, scene, scene.userData.camera);
          // setModal3(refPickHelper3.current.getModal);
        } else if (scene.userData.nombre === "sceneMatildaSelect") {
          refPickHelperSelectMatilda.current.pick(
            mouseMatildaSelect,
            scene,
            scene.userData.camera
          );
        } else if (scene.userData.nombre === "sceneJoeSelect") {
          refPickHelperSelectJoe.current.pick(
            mouseJoeSelect,
            scene,
            scene.userData.camera
          );
        }
        if (refRenderer.current) {
          refRenderer.current.render(scene, camera);
        }
      });
      // canvasCorgi.style.transform = `translateY(${window.scrollY}px)`;
      // refRenderer.current.setSize(
      //   canvas.clientWidth,
      //   canvas.clientHeight,
      //   false
      // );

      scenes2.forEach(function (scene, index) {
        refElement.current = scene.userData.element;
        // get the element that is a place holder for where we want to
        // draw the scene
        const element = scene.userData.element;
        const camera = scene.userData.camera;

        // get its position relative to the page's viewport
        const rect = element.getBoundingClientRect();

        // pickCorgi.pick(mouseCorgi, scene, scene.userData.camera);
        // check if it's offscreen. If so skip it
        if (
          rect.bottom < 0 ||
          rect.top > refRendererCorgi.current.domElement.clientHeight ||
          rect.right < 0 ||
          rect.left > refRendererCorgi.current.domElement.clientWidth
        ) {
          return; // it's off screen
        }

        // set the viewport
        const width = rect.right - rect.left;
        const height = rect.bottom - rect.top;
        const left = rect.left;
        const bottom =
          refRendererCorgi.current.domElement.clientHeight - rect.bottom;

        refRendererCorgi.current.setViewport(left, bottom, width, height);
        refRendererCorgi.current.setScissor(left, bottom, width, height);

        //camera.aspect = width / height; // not changing in this example
        scene.userData.camera.aspect = rect.width / rect.height;
        scene.userData.camera.updateProjectionMatrix();

        refRendererCorgi.current.render(scene, camera);
      });
      // Call tick again on the next frame
      // funcionMove();
      // window.requestAnimationFrame(tick);

      window.requestAnimationFrame(tick);
    };

    // refFuncionTick.current = funcionTick;
    tick();
    setTimeout(() => {
      // refPrimerAnimacion.current.play();
      // refPrimerAnimacion.current.clampWhenFinished = true;
      // refCorgi.current.rotation.x = Math.PI * 1.5;
    }, 100);
  };

  // useEffect(() => {
  //   // console.log("useEffect en modal1 es, ", modal1);
  //   if (modal1) {
  //     setTipoLente("lente21");
  //     setModel(refLente1Personaje.current.clone());
  //     setShow(true);
  //     // console.log("tick11 es, ", funcionTick);
  //     // window.cancelAnimationFrame(funcionTick);

  //     // refRenderer.current.dispose();
  //   } else if (modal2) {
  //     setTipoLente("lente22");
  //     setModel(refLente2Personaje.current.clone());

  //     setShow(true);
  //   } else if (modal3) {
  //     setTipoLente("lente23");
  //     setModel(refLente3Personaje.current.clone());

  //     setShow(true);
  //   }

  // }, [modal1, modal2, modal3]);
  const refPickHelper1 = useRef(null);
  const refPickHelper2 = useRef(null);
  const refPickHelper3 = useRef(null);
  useEffect(() => {
    principal();
  }, []);
  // useEffect(() => {
  //   console.log("ref modal es, ", refModal.current);
  // }, [refModal.current]);
  const callbackHideModal = () => {
    // console.log("callback hide");
    setModal1(false);
    setModal2(false);
    setModal3(false);
    refPickHelper1.current.setModal1(false);
    refPickHelper2.current.setModal1(false);
    refPickHelper3.current.setModal1(false);
    setShow(false);
  };

  useEffect(() => {
    // const boton = document.createElement("button");
    // boton.style.width = " 100px";
    // boton.style.height = "100px";
    // boton.innerHTML = "<Button>Prueba numero uno</Button>";
    // const element2 = document.createElement("div");
    // element2.className = "col-md-4 col-lg-4 mt-3 mb-3";
    // const element = document.createElement("div");
    // // element.className = "list-item col-md-4 col-lg-3";
    // element2.appendChild(element);
    // const sceneElement = document.createElement("div");
    // element.style.zIndex = "99999";
    // sceneElement.className = "scene-destacados";
    // element.appendChild(sceneElement);
    // // console.log("boton outer es, ", boton.outerHTML);
    // // boton.outerHTML = "<Button> Prueba numero uno  </Button> ";
    // element.appendChild(boton);
    // refPrueba.current.appendChild(element2);
    if (completo) {
      funcionLentesJoe();
    }
  }, [completo]);

  useEffect(() => {
    const funcionSelect = () => {
      // document.getElementById("c").style.offsetHeight = window.innerHeight;

      if (window.innerWidth < 768) {
        refDivSelect2.current.appendChild(refDivSelect.current);
        refDivSelect4.current.appendChild(refDivSkin.current);
        refDivSelect2.current.style.display = "block";
        refDivSelect3.current.style.display = "none";
      } else if (window.innerWidth >= 768) {
        refDivSelect2.current.style.display = "none";
        refDivSelect3.current.style.display = "block";
        refDivSelect3.current.appendChild(refDivSelect.current);
        refDivSelect5.current.appendChild(refDivSkin.current);
      }
    };
    funcionSelect();
    window.addEventListener("resize", funcionSelect);
    return () => {
      window.removeEventListener("resize", funcionSelect);
    };
  }, []);
  const funcionSkin = (valor) => {
    refMatildaSkin.current.material.color = new THREE.Color(valor);
    refJoeSkin.current.material.color = new THREE.Color(valor);
  };
  const funcionHair = (valor) => {
    refMatildaHair.current.material.color = new THREE.Color(valor);
    refJoeHair.current.material.color = new THREE.Color(valor);
  };

  const funcionLentesMatilda = () => {
    //Lente 1
    refLente1Personaje.current.scale.set(0.34, 0.33, 0.315);
    refLente1Personaje.current.position.y = 0.1396;
    refLente1Personaje.current.position.z = 0.115;
    refLente1Personaje.current.position.x = 0;

    //Lente 2
    refLente2Personaje.current.scale.set(0.0491, 0.0382, 0.0284);
    refLente2Personaje.current.position.y = 0.1396;
    refLente2Personaje.current.position.z = 0.4346;
    refLente2Personaje.current.position.x = 0;
    //Lente 3
    refLente3Personaje.current.scale.set(0.042, 0.04, 0.03);
    refLente3Personaje.current.position.y = 0.05;
    refLente3Personaje.current.position.z = 0.23;
    refLente3Personaje.current.position.x = 0;
  };
  const funcionLentesJoe = () => {
    //Lente 1
    refLente1Personaje.current.scale.set(0.34, 0.33, 0.315);
    refLente1Personaje.current.position.y = 0.1642;
    refLente1Personaje.current.position.z = 0.187;
    refLente1Personaje.current.position.x = 0;

    //Lente 2
    refLente2Personaje.current.scale.set(0.0493, 0.0382, 0.0284);
    refLente2Personaje.current.position.y = 0.1642;
    refLente2Personaje.current.position.z = 0.4838;
    refLente2Personaje.current.position.x = 0;

    //Lente 3
    refLente3Personaje.current.scale.set(0.042, 0.04, 0.03);
    refLente3Personaje.current.position.y = 0.054;
    refLente3Personaje.current.position.z = 0.275;
    refLente3Personaje.current.position.x = 0;
  };

  let variableAnimacion = false;
  let pasoHidden = false;
  useEffect(() => {
    // window.stop();
    return;
    if (!completo) return;
    console.log("completo es , ", completo);
    // refFuncionTick.current();
    // refPrimerAnimacion.current.play();
    // refPrimerAnimacion.current.clampWhenFinished = true;
    // refCorgi.current.rotation.x = Math.PI * 1.5;
    if (document.hasFocus()) {
      if (!variableAnimacion) {
        if (refPrimerAnimacion.current) {
          refPrimerAnimacion.current.play();
          refPrimerAnimacion.current.clampWhenFinished = true;
          refCorgi.current.rotation.x = Math.PI * 1.5;
          variableAnimacion = true;
          console.log("se hizo play al inicio1");
          setTimeout(() => {
            // refPrimerAnimacion.current.play();
            // refCorgi.current.rotation.x = Math.PI * 1.5;
          }, 100);
        }
      }
    }
    if (document.visibilityState === "visible") {
      if (!variableAnimacion) {
        refPrimerAnimacion.current.play();
        refPrimerAnimacion.current.clampWhenFinished = true;
        refCorgi.current.rotation.x = Math.PI * 1.5;
        variableAnimacion = true;
        console.log("se hizo play al inicio2");
      }
    }
    function visibilityListener() {
      console.log("document.visibilityState", document.visibilityState);
      if (document.visibilityState === "visible") {
        if (!variableAnimacion && pasoHidden) {
          refPrimerAnimacion.current.play();
          refPrimerAnimacion.current.clampWhenFinished = true;
          refCorgi.current.rotation.x = Math.PI * 1.5;
          variableAnimacion = true;
          console.log("se hizo play al inicio3");
        }
      } else {
        console.log("document.visibilityState2", document.visibilityState);
        console.log("es hidden");
        pasoHidden = true;
      }
    }

    if (document.hidden) {
      console.log("esta hidden!");
      pasoHidden = true;
    }

    function handleVisibilityChange(e) {
      // the page is visible
      console.log("evento", e.target);
      console.log("handleVisibilityChange", e.target.hidden);
      if (!e.target.hidden) {
        if (!variableAnimacion) {
          if (refPrimerAnimacion.current) {
            refPrimerAnimacion.current.play();
            refPrimerAnimacion.current.clampWhenFinished = true;
            refCorgi.current.rotation.x = Math.PI * 1.5;
            variableAnimacion = true;
            console.log("se hizo play al inicio4");
          }
        }
      }
    }

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange,
      false
    );
    // document.addEventListener("visibilitychange", visibilityListener, false);
    // }
    // window.addEventListener(
    //   "focus",
    //   function () {
    //     console.log("window focus");
    //     if (!variableAnimacion) {
    //       if (refPrimerAnimacion.current) {
    //         setTimeout(() => {
    //           console.log("se hizo play al inicio");
    //           // refPrimerAnimacion.current.play();
    //           // refCorgi.current.rotation.x = Math.PI * 1.5;

    //           variableAnimacion = true;
    //         }, 100);
    //       }
    //     }
    //   },
    //   false
    // );
    // document.addEventListener(
    //   "visibilitychange",
    //   function () {
    //     if (document.visibilityState === "visible") {
    //       console.log("visible 11");
    //       console.log("ref corgi es, ", refCorgi.current);
    //       // refPrimerAnimacion.current.play();
    //       // refCorgi.current.rotation.x = Math.PI * 1;
    //       // refCorgi.current.rotation.y = Math.PI * 0;
    //       // refCorgi.current.children[0].rotation.x = Math.PI * 0.5;
    //       // refCorgi.current.rotation.x = Math.PI * 1.5;
    //       // refCorgi.current.rotation.y = Math.PI * 0;
    //       // refCorgi.current.rotation.z = Math.PI * 1.5;
    //       // refCorgi.current.children[0].children[0].rotation.x = Math.PI * 1.2;
    //       // refCorgi.current.children[0].children[1].rotation.x = Math.PI * 1.2;
    //     } else {
    //       console.log("hidden 11");
    //     }
    //   },
    //   false
    // );
  }, [completo]);
  refFuncionModal1.current = () => {
    if (refLente1Personaje.current) {
      refTipoModal.current = "lente21";
      refModelModal.current = refLente1Personaje.current.clone();
      // setTipoLente("lente21");
      // setModel(refLente1Personaje.current.clone());
      setShow(true);
    }
  };

  refFuncionModal2.current = () => {
    if (refLente2Personaje.current) {
      refTipoModal.current = "lente22";
      refModelModal.current = refLente2Personaje.current.clone();
      setShow(true);
    }
  };
  // const funcionPrueba1 = () => {
  //   console.log("funcion prueba 2");
  //   if (refLente2Personaje.current) {
  //     setTipoLente("lente21");
  //     setModel(refLente1Personaje.current.clone());
  //     setShow(true);
  //   }
  // };
  // const funcionPrueba2 = () => {
  //   console.log("funcion prueba 2");
  //   if (refLente2Personaje.current) {
  //     setModel(refLente2Personaje.current.clone());
  //     setTipoLente("lente22");
  //     setShow(true);
  //   }
  // };
  // const funcionPrueba3 = () => {
  //   console.log("funcion prueba 2");
  //   if (refLente3Personaje.current) {
  //     setTipoLente("lente23");
  //     setModel(refLente3Personaje.current.clone());

  //     setShow(true);
  //   }
  // };
  refFuncionModal3.current = () => {
    if (refLente3Personaje.current) {
      refTipoModal.current = "lente23";
      refModelModal.current = refLente3Personaje.current.clone();

      setShow(true);
    }
  };
  return (
    // <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>

    <>
      {error && (
        <div className="div-error d-flex align-items-center justify-content-center">
          <Container fluid>
            <Row>
              <Col
                md={7}
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100%", width: "100%", marginTop: "-50vh" }}
              >
                <div>
                  <br />
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#2c2c2c",
                    }}
                    className="text-center"
                  >
                    Error in browser, restart the browser
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      {!completo && (
        // <div className="div-loading d-flex align-items-center justify-content-center">
        <div className="div-loading d-flex  justify-content-center">
          <Container fluid>
            <Row>
              <Col
                md={7}
                className="d-flex justify-content-center align-items-center"
                style={{
                  height: "100vh",
                  width: "100%",
                  // , marginTop: "-50vh"
                }}
              >
                <div
                  style={{
                    marginTop: "50vh",
                  }}
                  // className="d-flex justify-content-center align-items-center flex-column"
                >
                  <Circle
                    percent={loading}
                    strokeWidth="4"
                    // strokeColor="#b1fc03"
                    strokeColor="#640000"
                    style={{ width: "200px" }}
                    className="mx-auto d-block"
                    trailColor="#4a4a4a"
                  />
                  <br />
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#2c2c2c",
                    }}
                    className="text-center"
                  >
                    Loading...
                  </p>
                  <p className="text-center">
                    This site demostrate the effects 3D in website
                  </p>
                  {/* {window.innerWidth < 768 && (
                    <p className="text-center mt-2">
                      See the full version in desktop
                    </p>
                  )} */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      <Navbar
        bg="dark"
        expand="lg"
        fixed="top"
        className="menu d-flex flex-column"
        style={{
          zIndex: "9999",
        }}
      >
        <Container>
          <Nav className="mx-auto">
            <Nav.Link
              href="#home"
              style={{
                fontWeight: "700",
                color: "#FFFFFF",
              }}
            >
              SOWEME - GLASSES
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <canvas
        className="webgl"
        // ref={refCanvas}
        // ref={refDiv}
        id="c"
        style={{ zIndex: "1" }}
      ></canvas>
      <canvas
        className="webgl-corgi"
        ref={refCanvas}
        // ref={refDiv}
        id="canvas-corgi"
        style={{ zIndex: "9999" }}
      >
        <div ref={refPersonaje}></div>
      </canvas>
      {/* <canvas
        className="webgl2"
        //   ref={refCanvas2}
        // ref={refContentModal1}
        id="canvas-modal"
        style={{ zIndex: "0" }}
      ></canvas> */}
      <Container
        fluid
        className="container-principal"
        // style={{ marginTop: "100px" }}
      >
        <Row
        // style={{ height: "100vh" }}
        // style={{ height: "60vh" }}
        // className="row-smart"
        >
          {" "}
          <Col
            md={5}
            //  ref={refTexto}
            // style={{ paddingTop: "16vh" }}
            className="col-texto"
          >
            <div ref={refTexto}></div>
            {/* <div id="three-container"></div> */}
          </Col>
          <Col
            md={7}
            //  ref={refSmart}
            // style={{ paddingTop: "10vh" }}
            className="col-smart"
          >
            <div ref={refSmart}></div>
          </Col>
        </Row>
      </Container>
      {/* <div ref={refPrueba} style={{ position: "relative", zIndex: "999" }}>
        <Button className="mx-auto d-block">Prueba dos</Button>
      </div> */}
      <div className="div-gradiente"></div>
      {/* {completo && <Button>Prueba numero uno</Button>} */}
      <Container fluid>
        <div
          id="content-corgi"
          style={{
            width: "0px",
            height: "0px",
            zIndex: "99",
            // position: "fixed",
          }}
        ></div>

        <h2
          className="text-center"
          style={{ fontWeight: "800", position: "relative", zIndex: "999" }}
        >
          Recommended products
        </h2>
        <Container fluid>
          <Row
            // id="content2"
            // className="justify-content-md-center"
            style={{ marginTop: "100px" }}
          >
            <Col md={4}>
              <div ref={refLente1Col} className="div-col-4 mt-3 mb-3"></div>
            </Col>
            <Col md={4}>
              <div ref={refLente2Col} className="div-col-4 mt-3 mb-3"></div>
            </Col>
            <Col md={4}>
              <div ref={refLente3Col} className="div-col-4 mt-3 mb-3"></div>
            </Col>
          </Row>
        </Container>
        <Container style={{ marginTop: "240px", marginBottom: "240px" }} fluid>
          <h2 className="text-center" style={{ fontWeight: "800" }}>
            Test your glasses
          </h2>
          <Row id="content3">
            <div
              // className="d-flex flex-column justify-content-center"
              ref={refDivSelect2}
              style={{
                display: "none",
                background: "#ffffff",
                // zIndex: "999",
                position: "static",
                borderRadius: "15px",
                // border: "1px solid #000000",
              }}
              className="mt-3 mb-3 "
            >
              {/* <p className="text-center mt-1">Select character</p> */}
            </div>
            <div
              // className="d-flex flex-column justify-content-center"
              ref={refDivSelect4}
              style={{
                display: "block",
                background: "#ffffff",
                // zIndex: "999",
                position: "static",
                borderRadius: "15px",
                // border: "1px solid #000000",
                padding: "0px",
              }}
              className="mt-3 mb-3"
            >
              {/* <p className="text-center mt-1">Select character</p> */}
            </div>

            <Col
              md={3}
              style={
                {
                  // background: "#ffffff",
                  // // zIndex: "999",
                  // position: "static",
                  // borderRadius: "15px",
                  // // border: "1px solid #000000",
                  // padding: "0px",
                  // display: "block",
                  // height: "100%",
                }
              }
            >
              <Container
                fluid
                className="d-flex align-items-center "
                style={{
                  height: "100%",
                  background: "#ffffff",
                  borderRadius: "15px",
                  padding: "0px",
                }}
              >
                <div className="mx-auto d-block" ref={refDivSelect3}>
                  <p className="text-center mt-1" ref={refTextoSelect}>
                    Select character
                  </p>
                </div>
                <div ref={refDivSelect}></div>
              </Container>
            </Col>
            {/* <div id="content3" style={{ width: "100%", height: "100%" }}></div> */}
            <Col md={6} style={{ padding: "20px" }}>
              <div style={{ width: "100%" }} id="columna-2"></div>
            </Col>
            {/* <div
              className="d-flex flex-column justify-content-center"
              ref={refDivSelect}
              style={{ display: "none" }}
            ></div> */}
            <Col
              md={3}
              // style={{
              //   background: "#ffffff",
              //   zIndex: "999",
              //   position: "relative",
              //   borderRadius: "15px",
              //   // border: "1px solid #000000",
              //   padding: "0px",
              // }}
              ref={refDivSelect5}
            >
              <Container
                fluid
                ref={refDivSkin}
                style={{
                  background: "#ffffff",
                  zIndex: "999",
                  position: "relative",
                  borderRadius: "15px",
                  // border: "1px solid #000000",
                  padding: "0px",
                  height: "100%",
                }}
                className="d-flex align-items-center"
              >
                <div className="mx-auto d-block">
                  <p className="text-center mt-1">Skin color</p>
                  <Row>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#D4C0B1",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionSkin("#FFAE88")}

                        // #e0ac69
                      ></div>
                    </Col>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#BEA391",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionSkin("#AB755B")}
                        // #857051
                      ></div>
                    </Col>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#A88A75",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionSkin("#7A5441")}
                        // #66563E
                      ></div>
                    </Col>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#5D4132",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionSkin("#33231B")}
                        // #4F362A
                        // #664537
                      ></div>
                    </Col>
                  </Row>
                  <hr style={{ marginTop: "0.25rem", marginBottom: "0px" }} />
                  {/* Hair colors */}
                  <p className="text-center mt-1">Hair color</p>
                  <Row>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#98846E",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionHair("#574534")}
                      ></div>
                    </Col>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#45351E",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionHair("#241c11")}
                      ></div>
                    </Col>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#A08B43",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionHair("#735B21")}
                      ></div>
                    </Col>
                    <Col md={6} xs={3}>
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          background: "#000000",
                          cursor: "pointer",
                        }}
                        className="mx-auto d-block mt-3 mb-3"
                        onClick={() => funcionHair("#000000")}
                      ></div>
                    </Col>
                  </Row>
                </div>
              </Container>

              {/* <Button className="mx-auto d-block">Prueba dos</Button> */}
            </Col>
          </Row>
          <Container fluid style={{ padding: "-30px" }}>
            {/* <Row>
                <Col md={3} style={{ zIndex: "999999999" }}></Col>
                <Col md={6} className="mx-auto d-block"> */}
            {/* <Col md={12} className="mx-auto d-block"> */}
            <Row>
              {/* <Col
                  md={3}
                  style={{
                    zIndex: "999999999",
                    height: "300px",
                    background: "#FFFFFF",
                  }}
                ></Col> */}
              {/* <div
                  style={{
                    paddingRight: "30px",
                    paddingLeft: "30px",
                    margin: "0 auto",
                    zIndex: "99999999999",
                  }}
                  // ref={refCarousel2}
                  ref={setRef}
                ></div> */}
              <Col md={7} className="mx-auto d-block">
                {/* <Carousel
                    responsive={responsive}
                    infinite={true}
                    // removeArrowOnDeviceType={["tablet", "mobile"]}
                    autoPlay={false}
                    autoPlaySpeed={2000}
                    // afterChange={() => console.log("se cargo carousel")}
                    // id="content-div1"
                    // renderDotsOutside={true}
                    ref={(el) => (refCarousel.current = el)}
                    ssr={true}
                    // swipeable={false}
                    draggable={false}
                    // style={{ zIndex: "99" }}
                  > */}
                <Container
                  fluid
                  style={{
                    // background: "#FFFFFF",
                    // borderRadius: "15px",
                    height: "150px",
                  }}
                  className="mt-2 mb-2"
                >
                  <Row>
                    <Col xs={3} style={{ padding: "0px" }}>
                      <div
                        className="d-flex align-items-center justify-content-end"
                        style={{ height: "115px" }}
                      >
                        <img
                          src="./picks/back.png"
                          style={{
                            height: "auto",
                            width: "30px",
                            marginTop: "40px",
                            cursor: "pointer",
                            position: "relative",
                            zIndex: "999",
                          }}
                          onClick={() => {
                            if (
                              refCarousel1.current.style.display === "block"
                            ) {
                              refCarousel1.current.style.display = "none";
                              refCarousel2.current.style.display = "none";
                              refCarousel3.current.style.display = "block";
                              refLente1Personaje.current.visible = false;
                              refLente2Personaje.current.visible = false;
                              refLente3Personaje.current.visible = true;
                            } else if (
                              refCarousel2.current.style.display === "block"
                            ) {
                              refLente1Personaje.current.visible = true;
                              refLente2Personaje.current.visible = false;
                              refLente3Personaje.current.visible = false;
                              refCarousel1.current.style.display = "block";
                              refCarousel2.current.style.display = "none";
                              refCarousel3.current.style.display = "none";
                            } else if (
                              refCarousel3.current.style.display === "block"
                            ) {
                              refLente1Personaje.current.visible = false;
                              refLente2Personaje.current.visible = true;
                              refLente3Personaje.current.visible = false;
                              refCarousel1.current.style.display = "none";
                              refCarousel2.current.style.display = "block";
                              refCarousel3.current.style.display = "none";
                            }
                          }}
                          // className="float-right"
                        />
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div
                        style={{
                          // paddingRight: "30px",
                          // paddingLeft: "30px",
                          margin: "0 auto",
                          // zIndex: "1",
                          // display: "none",
                        }}
                        // ref={refCarousel2}
                        ref={setRef}
                      ></div>
                      <div
                        // style={{ paddingRight: "30px", paddingLeft: "30px" }}
                        // ref={refCarousel2}
                        ref={setRef2}
                      ></div>

                      <div
                        // style={{ paddingRight: "30px", paddingLeft: "30px" }}
                        // ref={refCarousel2}
                        ref={setRef3}
                      ></div>
                    </Col>
                    <Col xs={3} style={{ padding: "0px" }}>
                      <div
                        className="d-flex align-items-center justify-content-start"
                        style={{ height: "115px" }}
                      >
                        <img
                          src="./picks/next.png"
                          style={{
                            height: "auto",
                            width: "30px",
                            marginTop: "40px",
                            cursor: "pointer",
                            position: "relative",
                            zIndex: "999",
                          }}
                          onClick={() => {
                            if (
                              refCarousel1.current.style.display === "block"
                            ) {
                              refCarousel1.current.style.display = "none";
                              refCarousel2.current.style.display = "block";
                              refCarousel3.current.style.display = "none";
                              refLente1Personaje.current.visible = false;
                              refLente2Personaje.current.visible = true;
                              refLente3Personaje.current.visible = false;
                              // refLente2Personaje.current.scale.set(
                              //   0.052,
                              //   0.047,
                              //   0.041
                              // );
                              // refLente2Personaje.current.position.x = 0;
                              // refLente2Personaje.current.position.z = 0.49;
                              // refLente2Personaje.current.position.y = 0.145;
                            } else if (
                              refCarousel2.current.style.display === "block"
                            ) {
                              refLente1Personaje.current.visible = false;
                              refLente3Personaje.current.visible = true;
                              refLente2Personaje.current.visible = false;
                              refCarousel1.current.style.display = "none";
                              refCarousel2.current.style.display = "none";
                              refCarousel3.current.style.display = "block";
                            } else if (
                              refCarousel3.current.style.display === "block"
                            ) {
                              refLente1Personaje.current.visible = true;
                              refLente3Personaje.current.visible = false;
                              refLente2Personaje.current.visible = false;
                              refCarousel1.current.style.display = "block";
                              refCarousel2.current.style.display = "none";
                              refCarousel3.current.style.display = "none";
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Container>

                {/* </Carousel> */}
              </Col>
              {/* <Col md={3} style={{ zIndex: "999999999" }}></Col> */}
            </Row>
            {/* </Col>
                <Col md={3} style={{ zIndex: "999999999" }}></Col>
              </Row> */}
          </Container>
        </Container>
      </Container>
      <Footer />
      <ModalDestacado
        // show={show}
        show={show}
        // tipo={tipoLente}
        tipo={refTipoModal.current}
        callbackHideModal={callbackHideModal}
        // model={model}
        model={refModelModal.current}
        activarLenteModal={activarLenteModal}
      ></ModalDestacado>
      {/* </div> */}

      <p
        ref={textoLente1}
        className="text-center  mb-2"
        style={{ fontSize: "23px" }}
      >
        <b>Classic</b>
      </p>
      <p
        ref={textoLente2}
        className="text-center  mb-2"
        style={{ fontSize: "23px" }}
      >
        <b>Modern</b>
      </p>
      <p
        ref={textoLente3}
        className="text-center  mb-2"
        style={{ fontSize: "23px" }}
      >
        <b>Casual</b>
      </p>
      <p className="text-center" ref={textoRotate}>
        <i>Can rotate</i>
      </p>
    </>
  );
};

export default Canvas;
